import React, {Component} from 'react';
import {Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import moment from "moment/moment";
import Datetime from "react-datetime/DateTime";
import CustomerContractAccordion from "./CustomerContractAccordion";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import NumberFormat from 'react-number-format';
import Select from "../../../local_node_modules/react-select"
import InlineError from "../../../components/InlineError";
import SweetAlert from "react-bootstrap-sweetalert";
import DistributorContractAccordion from "./DistributorContractAccordion";
import {EntegratorConf} from "../../../constants";
import {disAllowChooseContractType, isVakifbankUser} from "../../../helper/permission";
import {EntegratorIdentifiers} from "../../../helper/enums";

class CustomerContractInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			page: 0,
			aPage: 0,
			size: 10,
			aSize: 5,
			csd: '',
			cfd: '',
			alert: null,
			selectedService: null,
			eFaturaSelected: false,
			eIrsaliyeSelected: false,
			kepikSelected: false,
			newContractModal: false,
			createModeAliasModal: false,
			createModeDespatchAliasModal: false,
			addAliasModal: false,
			editingAlias: false,
			editingAliasList: [],
			editingDespatchAliasList: [],
			error: {},
			serviceList: [],
			customerContractList: [],
			aliasList: [],
			disabledServiceList: [],
			selectServiceList: [],
			activeServiceList: [],
			activeService: false,
			ConfigurationList: [],
			aliasOptionListForDespatch: [],
			despatchAliasList: [],
			selectedStartDate: null,
			selectedServiceOption: null,
			isMobile:window.innerWidth > 991 ? false : true,
			senderAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: ''
			},
			recipientAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: ''
			},
			properSenderAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: ''
			},
			properRecipientAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: ''
			},
			senderDespatchAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: ''
			},
			recipientDespatchAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: ''
			},
			properSenderDespatchAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: ''
			},
			properRecipientDespatchAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: ''
			},
			editingSenderAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: ''
			},
			editingRecipientAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: ''
			},
			editingSenderDespatchAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: ''
			},
			editingRecipientDespatchAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: ''
			},
			data: {
				automaticExtension: false,
				customerContractServiceList: [],
				contractStartDate: null,
				contractFinishDate: null,
				rateType: 2,
			},
			gbFaturaAliasError: {
				show: false,
				message: 'e-Fatura etiketi mevcut !',
			},
			pkFaturaAliasError: {
				show: false,
				message: 'e-Fatura etiketi mevcut !',
			},
			gbIrsaliyeAliasError: {
				show: false,
				message: 'e-Irsaliye etiketi mevcut !',
			},
			pkIrsaliyeAliasError: {
				show: false,
				message: 'e-Irsaliye etiketi mevcut !',
			},
			currentStartDate: null,
			currentFinishDate: null,
			currentContractId: null
		};

		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.onSelectService = this.onSelectService.bind(this);
		this.onChangeServiceInfo = this.onChangeServiceInfo.bind(this);
		this.onChangeContractDate = this.onChangeContractDate.bind(this);
		this.onChangeAlias = this.onChangeAlias.bind(this);
		this.addAliasToEFatura = this.addAliasToEFatura.bind(this);
		this.splitAlias = this.splitAlias.bind(this);
		this.addNewContract = this.addNewContract.bind(this);
		this.setContractToCustomer = this.setContractToCustomer.bind(this);
		this.arrangeData = this.arrangeData.bind(this);
		this.arrangeAliasData = this.arrangeAliasData.bind(this);
		this.cancelCurrentContract = this.cancelCurrentContract.bind(this);
		this.onSelectExtension = this.onSelectExtension.bind(this);
		this.addNewAliasToContract = this.addNewAliasToContract.bind(this);
		this.openAddAliasModal = this.openAddAliasModal.bind(this);
		this.closeAddAliasModal = this.closeAddAliasModal.bind(this);
		this.saveNewAlias = this.saveNewAlias.bind(this);
		this.updateCustomer = this.updateCustomer.bind(this);
		this.existsAlready = this.existsAlready.bind(this);
		this.closeCreateModeAliasModal = this.closeCreateModeAliasModal.bind(this);
		this.updateAliasList = this.updateAliasList.bind(this);
		this.closeCreateModeDespatchAliasModal = this.closeCreateModeDespatchAliasModal.bind(this);
		this.arrangeDespatchAliasPkOptions = this.arrangeDespatchAliasPkOptions.bind(this);
		this.addAliasToEIrsaliye = this.addAliasToEIrsaliye.bind(this);
		this.setSelectedContract = this.setSelectedContract.bind(this);
		this.manipulateContractRateType = this.manipulateContractRateType.bind(this);
		this.manipulateContractFinishDate = this.manipulateContractFinishDate.bind(this);
		this.setConfigurationList = this.setConfigurationList.bind(this);
		this.updateContractDates = this.updateContractDates.bind(this);
		this.completeUpdate = this.completeUpdate.bind(this);
		this.validateAliasField = this.validateAliasField.bind(this);
		this.confirmEFaturaAlias = this.confirmEFaturaAlias.bind(this);
		this.confirmEIrsaliyeAlias = this.confirmEIrsaliyeAlias.bind(this);
		this.updateWorkscopeCode = this.updateWorkscopeCode.bind(this);
		this.deleteAlias = this.deleteAlias.bind(this);
		this.deleteService = this.deleteService.bind(this);
		this.deleteContract = this.deleteContract.bind(this);
		this.accordionDeleteSelectList = this.accordionDeleteSelectList.bind(this);
	}

	componentDidMount() {
		let customer = this.props.customer;
		let serviceList = this.props.services;
		if(!(this.props.currentUser.isEntegrator || this.props.isDistributor)){
			serviceList.map((result,index) =>{
				if (result.ublName === "EKonnektor"){
					serviceList.splice(index,1);
				}
			});
		}
		let suffix = this.props.currencyCodes.find(x => x.shortCode === 'TRY').symbol;

		this.setState({
			customerContractList: this.props.customerContractList
		});

		if (customer.recordId === null) {
			this.setState({
				mode: 'create',
				contractChangeForbidden: false
			})
		} else {
			if (!customer.customerContractList) {
				this.setState({
					mode: 'edit',
					contractChangeForbidden: false
				})
			} else {

				this.setState({
					mode: 'edit',
					contractChangeForbidden: true
				})
			}
		}

		if (this.props.customerContractList.length === 0) {
			serviceList.map((service) => {
				service.isSelected = false;
			});
		}
		this.setState({
			customer,
			serviceList,
			suffix
		})
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.customer !== prevProps.customer) {
			this.setState({
				customerContractList: this.props.customer.customerContractList,
				mode: this.props.customer.recordId !== null ? 'edit' : 'create'
			});
		}
	}

	accordionDeleteSelectList(data){
		let disabledList = this.state.disabledServiceList;
		if (disabledList.length > 0){
			let newList = disabledList.filter((f) => f.recordId !== data.recordId);
			this.setState({disabledServiceList: newList});
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;
		let result, error;

		result = validateField(rule, boundary, value);
		error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateAliasField(e, format) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;
		let result, error;

		result = validateField(format, undefined, value);
		error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error})
	}


	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onSelectService(row, e) {
		let serviceList = this.state.serviceList;
		let selectedService = e.target.checked ? row : null;

		if (row.ublName === 'EFatura') {
			let eFaturaSelected = e.target.checked;
			let createModeAliasModal = e.target.checked;
			if (this.state.eFaturaSelected) {
				this.setState({
					eFaturaSelected,
					selectedService: selectedService,
					aliasList: [],
					aliasOptionListForDespatch : []
				});
			} else {
				if (this.props.customer.corporateMail !== null && this.props.customer.corporateMail !== "" &&
					EntegratorConf.identifier !== EntegratorIdentifiers.MBT && EntegratorConf.identifier !== EntegratorIdentifiers.KOLAYSOFT ) {
					let fields = this.props.customer.corporateMail.split('@');
					this.setState({
						eFaturaSelected,
						createModeAliasModal,
						selectedService: row,
						senderAlias: {
							...this.state.senderAlias,
							workScopecode: "defaultgb@" + fields[1],
						},
						recipientAlias: {
							...this.state.recipientAlias,
							workScopecode: "defaultpk@" + fields[1],
						},
						properSenderAlias: {
							...this.state.properSenderAlias,
							workScopecode: 'urn:mail:' + "defaultgb@" + fields[1],
						},
						properRecipientAlias: {
							...this.state.properRecipientAlias,
							workScopecode: 'urn:mail:' + "defaultpk@" + fields[1],
						}
					})
				}
				if (EntegratorConf.identifier === EntegratorIdentifiers.MBT) {
					this.setState({
						eFaturaSelected,
						createModeAliasModal,
						selectedService: row,
						senderAlias: {
							workScopecode: "defaultgb@mbtfatura.com.tr",
						},
						recipientAlias: {
							workScopecode: "defaultpk@mbtfatura.com.tr"
						},
						properSenderAlias: {
							...this.state.properSenderAlias,
							service:'EFatura',
							workScopecode: 'urn:mail:' + "defaultgb@mbtfatura.com.tr",
						},
						properRecipientAlias: {
							...this.state.properRecipientAlias,
							service:'EFatura',
							workScopecode: 'urn:mail:' + "defaultpk@mbtfatura.com.tr",
						}
					})
				} else if (EntegratorConf.identifier === EntegratorIdentifiers.KOLAYSOFT) {
					this.setState({
						eFaturaSelected,
						createModeAliasModal,
						selectedService: row,
						senderAlias: {
							workScopecode: "defaultgb@kolaysoft.com.tr",
						},
						recipientAlias: {
							workScopecode: "defaultpk@kolaysoft.com.tr"
						},
						properSenderAlias: {
							...this.state.properSenderAlias,
							service:'EFatura',
							workScopecode: 'urn:mail:' + "defaultgb@kolaysoft.com.tr",
						},
						properRecipientAlias: {
							...this.state.properRecipientAlias,
							service:'EFatura',
							workScopecode: 'urn:mail:' + "defaultpk@kolaysoft.com.tr",
						}
					})
				}else if (EntegratorConf.identifier !== EntegratorIdentifiers.MBT && EntegratorConf.identifier !== EntegratorIdentifiers.KOLAYSOFT){
					this.setState({
						eFaturaSelected,
						createModeAliasModal,
						selectedService: row,
						senderDespatchAlias: {
							workScopecode: "",
						},
						recipientDespatchAlias: {
							workScopecode: "",
						},
						properSenderDespatchAlias: {
							...this.state.properSenderDespatchAlias,
							workScopecode: 'urn:mail:',
						},
						properRecipientDespatchAlias: {
							...this.state.properRecipientDespatchAlias,
							workScopecode: 'urn:mail:',
						}
					});
				}
			}
		} else if (row.ublName === 'EIrsaliye') {
			let eIrsaliyeSelected = !this.state.eIrsaliyeSelected;
			let createModeDespatchAliasModal = !this.state.createModeDespatchAliasModal;
			if (this.state.eIrsaliyeSelected) {
				this.setState({
					eIrsaliyeSelected,
					selectedService: selectedService,
					despatchAliasList: []
				})
			} else {
				let aliasList = this.state.aliasList ? deepCopyObject(this.state.aliasList) : this.fillAliasList(true);
				let eFaturaAliasRadio = null;
				let newAliasRadio = null;
				aliasList.length > 0 ? eFaturaAliasRadio = true : newAliasRadio = true;
				if (EntegratorConf.identifier === EntegratorIdentifiers.KOLAYSOFT && !eFaturaAliasRadio) {
					this.setState({
						eIrsaliyeSelected,
						createModeDespatchAliasModal,
						eFaturaAliasRadio,
						newAliasRadio,
						selectedService: row,
						senderDespatchAlias: {
							workScopecode: "irsaliyegb@kolaysoft.com.tr",
						},
						recipientDespatchAlias: {
							workScopecode: "irsaliyepk@kolaysoft.com.tr"
						},
						properSenderDespatchAlias: {
							...this.state.properSenderAlias,
							workScopecode: 'urn:mail:' + "irsaliyegb@kolaysoft.com.tr",
						},
						properRecipientDespatchAlias: {
							...this.state.properRecipientAlias,
							workScopecode: 'urn:mail:' + "irsaliyepk@kolaysoft.com.tr",
						}
					})
				} else if (EntegratorConf.identifier === EntegratorIdentifiers.MBT && !eFaturaAliasRadio) {
					this.setState({
						eIrsaliyeSelected,
						createModeDespatchAliasModal,
						eFaturaAliasRadio,
						newAliasRadio,
						selectedService: row,
						senderDespatchAlias: {
							workScopecode: "irsaliyegb@mbtfatura.com.tr",
						},
						recipientDespatchAlias: {
							workScopecode: "irsaliyepk@mbtfatura.com.tr"
						},
						properSenderDespatchAlias: {
							...this.state.properSenderAlias,
							workScopecode: 'urn:mail:' + "irsaliyegb@mbtfatura.com.tr",
						},
						properRecipientDespatchAlias: {
							...this.state.properRecipientAlias,
							workScopecode: 'urn:mail:' + "irsaliyepk@mbtfatura.com.tr",
						}
					})
				} else if (this.props.customer.corporateMail !== null && this.props.customer.corporateMail !== "" &&
					(EntegratorConf.identifier !== EntegratorIdentifiers.KOLAYSOFT &&
					EntegratorConf.identifier !== EntegratorIdentifiers.MBT)) {
					let fields = this.props.customer.corporateMail.split('@');
					this.setState({
						eIrsaliyeSelected,
						createModeDespatchAliasModal,
						eFaturaAliasRadio,
						newAliasRadio,
						selectedService: row,
						senderDespatchAlias: {
							workScopecode: "irsaliyegb@" + fields[1],
						},
						recipientDespatchAlias: {
							workScopecode: "irsaliyepk@" + fields[1],
						},
						properSenderDespatchAlias: {
							...this.state.properSenderDespatchAlias,
							workScopecode: 'urn:mail:' + "irsaliyegb@" + fields[1],
						},
						properRecipientDespatchAlias: {
							...this.state.properRecipientDespatchAlias,
							workScopecode: 'urn:mail:' + "irsaliyepk@" + fields[1],
						}
					})
				}
				else {
					this.setState({
						eIrsaliyeSelected,
						createModeDespatchAliasModal,
						eFaturaAliasRadio,
						newAliasRadio,
						selectedService: row,
						senderDespatchAlias: {
							workScopecode: "",
						},
						recipientDespatchAlias: {
							workScopecode: "",
						},
						properSenderDespatchAlias: {
							...this.state.properSenderDespatchAlias,
							workScopecode: 'urn:mail:',
						},
						properRecipientDespatchAlias: {
							...this.state.properRecipientDespatchAlias,
							workScopecode: 'urn:mail:',
						}
					});
				}
			}
		}

		let customerContractServiceList = [...this.state.data.customerContractServiceList];
		let ccs = this.convertServiceToCcs(selectedService ? selectedService : row);

		let found = false;
		let indexOfFound = null;
		customerContractServiceList.map(iter => {
			if (iter.service.recordId === ccs.service.recordId) {
				found = true;
				indexOfFound = customerContractServiceList.indexOf(iter);
			}
		});

		if (found === true) {
			customerContractServiceList.splice(indexOfFound, 1);
			found = false;
			indexOfFound = null;
		} else {
			customerContractServiceList.push(ccs);
		}

		this.setState({
			serviceList,
			selectServiceList: customerContractServiceList,
			data: {
				...this.state.data,
				customerContractServiceList
			}
		}, () => this.setContractToCustomer());
	}

	fillAliasList(data) {
		let aliasList = [];
		let customerContractList = deepCopyObject(this.props.customer.customerContractList);
		if (customerContractList !== null){
			customerContractList.map(cc => {
				cc.customerContractServiceList.map(ccs => {
					if (ccs.service.recordId === 2) {
						aliasList = ccs.aliasList;
					}
				})
			});
		}
		if (data) {
			this.setState({aliasList})
		}
		return aliasList;
	}

	convertServiceToCcs(selectedService) {
		let aliasList = [];
		let defaultAlias = {
			workScopecode: null
		};

		if (selectedService.recordId !== 2 && selectedService.recordId !== 6) {
			aliasList.push(defaultAlias);
		}
		let ccs = {
			explanation: selectedService.explanation,
			price: selectedService.price,
			terminated: false,
			service: {recordId: selectedService.recordId},
			aliasList: aliasList
		};
		return ccs
	}

	onChangeServiceInfo(cell, row) {
		let serviceList = deepCopyObject(this.state.serviceList);
		let index = this.state.serviceList.indexOf(row);
		if (cell.target.name === "price") {
			serviceList[index].price = cell.value;
		} else if (cell.target.name === "explanation") {
			serviceList[index].explanation = cell.target.value;
		}

		let customerContractServiceList = this.state.data.customerContractServiceList;
		for (let ccsIter = 0; ccsIter < customerContractServiceList.length; ccsIter++) {
			if (customerContractServiceList[ccsIter].service.recordId === row.recordId) {
				if (cell.target.name === "price") {
					customerContractServiceList[ccsIter].price = cell.value;
				}
				if (cell.target.name === "explanation") {
					customerContractServiceList[ccsIter].explanation = cell.target.value;
				}
			}
		}

		this.setState({
			serviceList,
			data: {
				...this.state.data,
				customerContractServiceList
			}
		}, () => this.setContractToCustomer())
	}

	onChangeContractDate(selection, name) {
		if (name === 'contractStartDate') {
			let contractStartDate = deepCopyObject(this.state.data.contractStartDate);
			let contractFinishDate = deepCopyObject(this.state.data.contractFinishDate);

			if (!(typeof selection === "string")) {
				let temp = selection.format("YYYY-MM-DD");
				let csd = moment(temp).format("YYYY-MM-DD");

				let clone = selection.clone();
				let date = clone.format("YYYY-MM-DD");
				contractStartDate = date;


				let fTemp = selection.format("YYYY-MM-DD");
				let cfd = moment(fTemp).add(1, 'years').format("YYYY-MM-DD");
				let fClone = selection.clone().add(1, 'years');
				let fDate = fClone.format("YYYY-MM-DD");
				contractFinishDate = fDate;

				this.setState({
					csd,
					cfd,
					selectedStartDate: selection,
					data: {
						...this.state.data,
						contractStartDate,
						contractFinishDate
					},
				}, () => this.setContractToCustomer(this.state.data));
			}
		} else {
			let contractFinishDate = deepCopyObject(this.state.data.contractFinishDate);
			if (!(typeof selection === "string")) {
				let temp = selection.format("YYYY-MM-DD");
				let cfd = moment(temp).format("YYYY-MM-DD");
				let clone = selection.clone();
				let date = clone.format("YYYY-MM-DD");
				contractFinishDate = date;
				this.setState({
					cfd,
					data: {
						...this.state.data,
						contractFinishDate
					}
				}, () => this.setContractToCustomer(this.state.data));
			}
		}
	}

	onChangeAlias(e) {

		let regex = new RegExp(/[ şŞıİçÇöÖüÜĞğ]/g);
		if(e.target.value.match(regex) === null) {
			if (e.target.name === 'senderAlias') {
				this.setState({
					senderAlias: {
						...this.state.senderAlias,
						workScopecode: e.target.value,
						service: 'EFatura'
					},
					properSenderAlias: {
						...this.state.properSenderAlias,
						workScopecode: e.target.value ? 'urn:mail:' + e.target.value : "",
						service: 'EFatura'
					}
				});
			} else if (e.target.name === 'recipientAlias') {
				this.setState({
					recipientAlias: {
						...this.state.recipientAlias,
						workScopecode: e.target.value,
						service: 'EFatura'
					},
					properRecipientAlias: {
						...this.state.properRecipientAlias,
						workScopecode: e.target.value ? 'urn:mail:' + e.target.value : "",
						service: 'EFatura'
					}
				});
			}
		}
	}

	onChangeDespatchAlias(e, name) {
		let aliasOptionListForDespatch = deepCopyObject(this.state.aliasOptionListForDespatch);
		let properSenderDespatchAlias = {};
		let properRecipientDespatchAlias = {};
		let senderDespatchAlias = this.state.senderDespatchAlias;
		let recipientDespatchAlias = this.state.recipientDespatchAlias;

		if (this.state.eFaturaAliasRadio) {
			if (name === 'senderDespatchAlias') {
				properSenderDespatchAlias.workScopecode = e && e.value;
				properSenderDespatchAlias.userRolecode = 'GB';
				properSenderDespatchAlias.service = 'EIrsaliye';
				senderDespatchAlias = {};
				senderDespatchAlias.workScopecode = e.value.split("urn:mail:")[1];
				senderDespatchAlias.userRolecode = 'GB';
				senderDespatchAlias.service = 'EIrsaliye';
				this.setState({properSenderDespatchAlias, senderDespatchAlias})
			}
			if (name === 'recipientDespatchAlias') {
				properRecipientDespatchAlias.workScopecode = e && e.value;
				properRecipientDespatchAlias.userRolecode = 'PK';
				properRecipientDespatchAlias.service = 'EIrsaliye';
				recipientDespatchAlias = {};
				recipientDespatchAlias.workScopecode = e.value.split("urn:mail:")[1];
				recipientDespatchAlias.userRolecode = 'GB';
				recipientDespatchAlias.service = 'EIrsaliye';
				this.setState({properRecipientDespatchAlias, recipientDespatchAlias})
			}
		}
		if (this.state.newAliasRadio) {
			let regex = new RegExp(/[ şŞıİçÇöÖüÜĞğ]/g);
			if (e.target.value.match(regex) === null) {
				if (e.target.name === 'senderDespatchAlias') {
					this.setState({
						senderDespatchAlias: {
							...this.state.senderDespatchAlias,
							workScopecode: e.target.value,
							service: 'EIrsaliye'
						},
						properSenderDespatchAlias: {
							...this.state.properSenderDespatchAlias,
							workScopecode: 'urn:mail:' + e.target.value,
							service: 'EIrsaliye'
						}
					});
				} else if (e.target.name === 'recipientDespatchAlias') {
					this.setState({
						recipientDespatchAlias: {
							...this.state.recipientDespatchAlias,
							workScopecode: e.target.value,
							service: 'EIrsaliye'
						},
						properRecipientDespatchAlias: {
							...this.state.properRecipientDespatchAlias,
							workScopecode: 'urn:mail:' + e.target.value,
							service: 'EIrsaliye'
						}
					});
				}
			}
		}
		// let aliasOptionListForDespatch = initList.filter(n => {
		// 	return n.service !== '_new'
		// });
		this.setState({aliasOptionListForDespatch})
	}

	splitAlias(alias, type) {
		if (alias !== null && alias !== "") {
			let res = alias.workScopecode.split("@");
			if (res[0][res[0].length - 2] === type[0] && res[0][res[0].length - 1] === type[1]) {
				return alias;
			} else {
				if (alias && alias.workScopecode)
					alias.workScopecode = res[0] + type + "@" + res[1];
				return alias;
			}
		}
	}

	addAliasToEFatura() {
		let customerContractServiceList = this.state.data.customerContractServiceList;
		let aliasList = this.state.aliasList;
		let aliasOptionListForDespatch = this.state.aliasOptionListForDespatch;
		let fakeSInput = {
			target: {
				id: 'tSenderAlias',
				value: this.state.senderAlias.workScopecode,
				dataset: {
					vdata: 'email',
					vlength: '1,350'
				}
			}
		};
		let fakeRInput = {
			target: {
				id: 'tRecipientAlias',
				value: this.state.recipientAlias.workScopecode,
				dataset: {
					vdata: 'email',
					vlength: '1,350'
				}
			}
		};

		if (fakeSInput.target.value !== "" && fakeSInput.target.value !== null) {
			if (fakeRInput.target.value === null || fakeRInput.target.value === "") {
				this.validateField(fakeSInput);
			}
		}
		if (fakeRInput.target.value !== "" && fakeRInput.target.value !== null) {
			if (fakeSInput.target.value === null || fakeSInput.target.value === "") {
				this.validateField(fakeRInput);
			}
		}else if ((fakeSInput.target.value === "" && fakeRInput.target.value === "") || (fakeRInput.target.value === null && fakeSInput.target.value === null)) {
			this.validateField(fakeSInput);
			this.validateField(fakeRInput);
		}
		if ((fakeSInput.target.value !== "" && fakeSInput.target.value !== null) && (fakeRInput.target.value !== "" && fakeRInput.target.value !== null)) {
			this.validateField(fakeSInput);
			this.validateField(fakeRInput);
		}
		for (let ccsIter = 0; ccsIter < customerContractServiceList.length; ccsIter++) {
			if (customerContractServiceList[ccsIter].service.recordId === 2) {
				aliasList = customerContractServiceList[ccsIter].aliasList
			}
		}

		if ((this.state.error.tSenderAlias && !this.state.error.tSenderAlias.valid) || (this.state.error.tRecipientAlias && !this.state.error.tRecipientAlias.valid)) {
			Alert.error('Geçerli bir etiket giriniz', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		} else {
			let properSenderAlias = this.splitAlias(this.state.properSenderAlias, 'gb');
			let properRecipientAlias = this.splitAlias(this.state.properRecipientAlias, 'pk');

			if (properSenderAlias.workScopecode !== "" || properRecipientAlias.workScopecode !== "") {
				if ((properSenderAlias.workScopecode === "" || properRecipientAlias.workScopecode === "") ||
					(fakeRInput.target.value === "" || fakeRInput.target.value === null) ||
					(fakeSInput.target.value === "" || fakeSInput.target.value === null)) {
					this.setState({
						alert: (
							<SweetAlert showCancel warning
										confirmBtnText="Onayla"
										cancelBtnText="İptal"
										confirmBtnBsStyle="danger"
										cancelBtnBsStyle="default"
										title="UYARI"
										onConfirm={() => this.confirmEFaturaAlias(aliasList, aliasOptionListForDespatch, customerContractServiceList)}
										onCancel={() => this.setState({alert: null})}
							>
								{'Etiketlerinizden birini girmediniz, devam etmek istediğinize emin misiniz?'}
							</SweetAlert>
						)
					});
				} else {
					this.confirmEFaturaAlias(aliasList, aliasOptionListForDespatch, customerContractServiceList);
				}
			}
		}
	}

	confirmEFaturaAlias(aliasList, aliasOptionListForDespatch, customerContractServiceList) {

		if ((this.state.properSenderAlias && this.state.properSenderAlias.workScopecode) &&
			(this.state.senderAlias.workScopecode !== "" && this.state.senderAlias.workScopecode !== null)) {
			aliasList.push(this.splitAlias(this.state.properSenderAlias, 'gb'));
			aliasOptionListForDespatch.push(this.state.properSenderAlias);
		}

		if ((this.state.properRecipientAlias && this.state.properRecipientAlias.workScopecode) &&
			(this.state.recipientAlias.workScopecode !== null && this.state.recipientAlias.workScopecode !== "")) {
			aliasList.push(this.splitAlias(this.state.properRecipientAlias, 'pk'));
			aliasOptionListForDespatch.push(this.state.properRecipientAlias);
		}


		if (this.state.editingAlias) {
			let editingAliasList = [];
			if (this.state.properSenderAlias && this.state.properSenderAlias.workScopecode)
				editingAliasList.push(this.splitAlias(this.state.properSenderAlias,'gb'));

			if (this.state.properRecipientAlias && this.state.properRecipientAlias.workScopecode)
				editingAliasList.push(this.splitAlias(this.state.properRecipientAlias,'pk'));
			this.setState({editingAliasList})
		}

		for (let iter = 0; iter < customerContractServiceList.length; iter++) {
			if (customerContractServiceList[iter].service.recordId === 2) {
				customerContractServiceList[iter].aliasList = aliasList
			}
		}

		this.setState({
			alert: null,
			aliasList,
			data: {
				...this.state.data,
				customerContractServiceList
			},
			senderAlias: {
				workScopecode: '',
				userRolecode: 'GB'
			},
			recipientAlias: {
				workScopecode: '',
				userRolecode: 'PK'
			},
			properSenderAlias: {
				workScopecode: '',
				userRolecode: 'GB'
			},
			properRecipientAlias: {
				workScopecode: '',
				userRolecode: 'PK'
			}
		}, () => this.setContractToCustomer(), this.props.passRecentAliasList(aliasList));
	}

	addAliasToEIrsaliye() {
		let customerContractServiceList = this.state.data.customerContractServiceList;
		let despatchAliasList = this.state.despatchAliasList;
		let fakeSInput = {
			target: {
				id: 'tSenderDespatchAlias',
				value: this.state.senderDespatchAlias.workScopecode,
				dataset: {
					vdata: 'email',
					vlength: '1,350'
				}
			}
		};
		let fakeRInput = {
			target: {
				id: 'tRecipientDespatchAlias',
				value: this.state.recipientDespatchAlias.workScopecode,
				dataset: {
					vdata: 'email',
					vlength: '1,350'
				}
			}
		};

		if (fakeSInput.target.value !== "" && fakeSInput.target.value !== null) {
			if (fakeRInput.target.value === null || fakeRInput.target.value === "") {
				this.validateField(fakeSInput);
			}
		}
		if (fakeRInput.target.value !== "" && fakeRInput.target.value !== null) {
			if (fakeSInput.target.value === null || fakeSInput.target.value === "") {
				this.validateField(fakeRInput);
			}
		}else if ((fakeSInput.target.value === "" && fakeRInput.target.value === "") || (fakeRInput.target.value === null && fakeSInput.target.value === null)) {
			this.validateField(fakeSInput);
			this.validateField(fakeRInput);
		}
		if ((fakeSInput.target.value !== "" && fakeSInput.target.value !== null) && (fakeRInput.target.value !== "" && fakeRInput.target.value !== null)) {
			this.validateField(fakeSInput);
			this.validateField(fakeRInput);
		}

		for (let ccsIter = 0; ccsIter < customerContractServiceList.length; ccsIter++) {
			if (customerContractServiceList[ccsIter].service.recordId === 6) {
				despatchAliasList = customerContractServiceList[ccsIter].aliasList
			}
		}

		if ((this.state.error.tSenderDespatchAlias && !this.state.error.tSenderDespatchAlias.valid) || (this.state.error.tRecipientDespatchAlias && !this.state.error.tRecipientDespatchAlias.valid)) {
			Alert.error('Geçerli bir etiket giriniz', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		} else {
			let properSenderDespatchAlias = this.splitAlias(this.state.properSenderDespatchAlias, 'gb');
			let properRecipientDespatchAlias = this.splitAlias(this.state.properRecipientDespatchAlias, 'pk');

			if (properSenderDespatchAlias.workScopecode !== "" || properRecipientDespatchAlias.workScopecode !== "") {
				if ((properSenderDespatchAlias.workScopecode === "" || properRecipientDespatchAlias.workScopecode === "") ||
					(fakeRInput.target.value === "" || fakeRInput.target.value === null) ||
					(fakeSInput.target.value === "" || fakeSInput.target.value === null)) {
					this.setState({
						alert: (
							<SweetAlert showCancel warning
										confirmBtnText="Onayla"
										cancelBtnText="İptal"
										confirmBtnBsStyle="danger"
										cancelBtnBsStyle="default"
										title="UYARI"
										onConfirm={() => this.confirmEIrsaliyeAlias(despatchAliasList, customerContractServiceList)}
										onCancel={() => this.setState({alert: null})}
							>
								{'Etiketlerinizden birini girmediniz, devam etmek istediğinize emin misiniz?'}
							</SweetAlert>
						)
					});
				} else {
					this.confirmEIrsaliyeAlias(despatchAliasList, customerContractServiceList);
				}
			}
		}
	}

	confirmEIrsaliyeAlias(despatchAliasList, customerContractServiceList) {
		if (((this.state.properSenderDespatchAlias && this.state.properSenderDespatchAlias.workScopecode) &&
			(this.state.senderDespatchAlias.workScopecode !== "" && this.state.senderDespatchAlias.workScopecode !== null))) {
			despatchAliasList.push(this.splitAlias(this.state.properSenderDespatchAlias, 'gb'));
		}

		if (((this.state.properRecipientDespatchAlias && this.state.properRecipientDespatchAlias.workScopecode) &&
			(this.state.recipientDespatchAlias.workScopecode !== null && this.state.recipientDespatchAlias.workScopecode !== ""))) {
			despatchAliasList.push(this.splitAlias(this.state.properRecipientDespatchAlias, 'pk'));
		}

		if (this.state.editingAlias) {
			let editingAliasList = [];
			editingAliasList.push(this.state.properSenderDespatchAlias);
			editingAliasList.push(this.state.properRecipientDespatchAlias);
			this.setState({editingAliasList})
		}

		for (let iter = 0; iter < customerContractServiceList.length; iter++) {
			if (customerContractServiceList[iter].service.recordId === 6) {
				customerContractServiceList[iter].aliasList = despatchAliasList;
			}
		}

		this.setState({
			alert:null,
			despatchAliasList,
			data: {
				...this.state.data,
				customerContractServiceList
			},
			senderDespatchAlias: {
				workScopecode: '',
				userRolecode: 'GB',
				service: 'EIrsaliye'
			},
			recipientDespatchAlias: {
				workScopecode: '',
				userRolecode: 'PK',
				service: 'EIrsaliye'
			},
			properSenderDespatchAlias: {
				workScopecode: 'urn:mail:',
				userRolecode: 'GB',
				service: 'EIrsaliye'
			},
			properRecipientDespatchAlias: {
				workScopecode: 'urn:mail:',
				userRolecode: 'PK',
				service: 'EIrsaliye'
			}
		}, () => this.setContractToCustomer(), this.props.passRecentAliasList(despatchAliasList));
	}

	setContractToCustomer() {
		if (this.state.mode === 'create') {
			this.props.setContractToCustomer(this.state.data)
		}
	}


	async openContractModal() {
		let params = {
			url: `/customer/getCustomerServiceList`,
			data: this.props.customer.recordId,
			method: 'post'
		};
		const response = await request(params);
		let responseList = response.data;
		let disabledServiceList = this.state.disabledServiceList;

		if (disabledServiceList.length > 0 && responseList.length > 0) {
			for (let i = 0; i < responseList; i++) {
				disabledServiceList.push(responseList[i]);
			}
		} else {
			disabledServiceList = response.data;
		}
		let selectServiceList = this.state.selectServiceList;
		if (selectServiceList.length > 0) {
			for (let i = 0; i < selectServiceList.length; i++) {
				disabledServiceList.push(selectServiceList[i]);
			}
		}
		this.setState({ disabledServiceList: disabledServiceList });

		if (this.state.disabledServiceList !== undefined && this.state.disabledServiceList.length > 0) {
			let activeServiceList = [];
			for (let i = 0; i < this.state.serviceList.length; i++) {
				const filter = this.state.disabledServiceList.filter(
					(f) => f.service.recordId === this.state.serviceList[i].recordId
				);
				if (filter[0] === undefined || filter[0].service.recordId !== this.state.serviceList[i].recordId) {
					activeServiceList.push(this.state.serviceList[i]);
				}
			}
			this.setState({ activeServiceList: activeServiceList, activeService: true });
		}

		this.setState(
			{
				data: {
					...this.state.data,
					customerContractServiceList: [],
					rateType: { value: 2, label: "Kontörlü" }
				},
				newContractModal: true
			},
			() => this.existsAlready()
		);
	}

	addNewContract() {
		let isValid = this.validateComponent();

		if (isValid.valid && this.state.data.customerContractServiceList.length !== 0) {
			const contractData = {
				...this.state.data,
				rateType: this.state.data.rateType?.value || this.state.data.rateType 
			};

			this.props.addContractToCustomer(contractData);

			this.setState({
				cfd: null,
				csd: null,
				newContractModal: false,
				customerContractList: this.props.customerContractList,
				data: {
					...this.state.data,
					automaticExtension: false,
					customerContractServiceList: [],
					contractStartDate: null,
					contractFinishDate: null,
				},
			});
		} else {
			if (this.state.data.customerContractServiceList.length !== 0) {
				Alert.error('Sözleşme tarih aralığı giriniz', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			} else {
				Alert.error('Hizmet seçiniz', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}
		}
	}


	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false,
			manual: false
		});
	}

	arrangeAliasData(page, size) {
		this.setState({
			aPage: page,
			aSize: size,
			loading: false
		});
	}

	cancelCurrentContract() {
		let newContractModal = this.state.newContractModal;
		let eFaturaSelected = deepCopyObject(this.state.eFaturaSelected);
		if (newContractModal) {
			eFaturaSelected = false
		}
		this.setState({
			cfd: null,
			csd: null,
			aliasList: [],
			senderAlias: {
				workScopecode: '',
				userRolecode: 'GB'
			},
			recipientAlias: {
				workScopecode: '',
				userRolecode: 'PK'
			},
			data: {
				automaticExtension: false,
				customerContractServiceList: [],
				contractStartDate: null,
				contractFinishDate: null,
				rateType: 2
			},
			newContractModal: false,
			eFaturaSelected
		})
	}

	onSelectExtension() {
		let automaticExtension = !this.state.data.automaticExtension;
		this.setState({
			data: {
				...this.state.data,
				automaticExtension
			}
		})
	}

	addNewAliasToContract() {
		let aliasList = [];
		let eFaturaContractIndex = null;
		let eFaturaIndex = null;
		let eFaturaCcsId = null;
		let eIrsaliyeContractIndex = null;
		let eIrsaliyeIndex = null;
		let eIrsaliyeCcsId = null;
		let customerContractList = this.state.customerContractList;
		customerContractList.map((contract, cIndex) => {
			contract.customerContractServiceList.map((ccs, ccsIndex) => {
				if ((ccs.service.recordId === 2 || ccs.service === 2) && !ccs.terminated) {
					eFaturaContractIndex = cIndex;
					eFaturaIndex = ccsIndex;
					eFaturaCcsId = ccs.id;
					ccs.aliasList.map(alias => {
						aliasList.push(alias)
					});
				}
				if ((ccs.service.recordId === 6 || ccs.service === 6) && !ccs.terminated) {
					eIrsaliyeContractIndex = cIndex;
					eIrsaliyeIndex = ccsIndex;
					eIrsaliyeCcsId = ccs.id;
					ccs.aliasList.map(alias => aliasList.push(alias));
				}
			});
		});
		this.openAddAliasModal(eFaturaContractIndex, eFaturaIndex, eFaturaCcsId, eIrsaliyeContractIndex, eIrsaliyeIndex, eIrsaliyeCcsId);
	}

	openAddAliasModal(eFaturaContractIndex, eFaturaIndex, eFaturaCcsId, eIrsaliyeContractIndex, eIrsaliyeIndex, eIrsaliyeCcsId) {
		this.setState({
			addAliasModal: true,
			eFaturaContractIndex,
			eFaturaIndex,
			eFaturaCcsId,
			eIrsaliyeContractIndex,
			eIrsaliyeIndex,
			eIrsaliyeCcsId
		});
		let fields = this.props.customer.corporateMail.split('@');
		if(this.state.selectedServiceOption === 2){
			this.setState({
				senderAlias:{
					...this.state.senderAlias,
					workScopecode: "defaultgb@" + fields[1],
				},
				recipientAlias: {
					...this.state.recipientAlias,
					workScopecode: "defaultpk@" + fields[1],
				},
				properSenderAlias: {
					...this.state.properSenderAlias,
					workScopecode: 'urn:mail:' + "defaultgb@" + fields[1],
				},
				properRecipientAlias: {
					...this.state.properRecipientAlias,
					workScopecode: 'urn:mail:' + "defaultpk@" + fields[1],
				}
			});
		}else if(this.state.selectedServiceOption === 6){
			this.setState({
				senderAlias:{
					...this.state.senderAlias,
					workScopecode: "irsaliyegb@" + fields[1],
				},
				recipientAlias: {
					...this.state.recipientAlias,
					workScopecode: "irsaliyepk@" + fields[1],
				},
				properSenderAlias: {
					...this.state.properSenderAlias,
					workScopecode: 'urn:mail:' + "irsaliyegb@" + fields[1],
				},
				properRecipientAlias: {
					...this.state.properRecipientAlias,
					workScopecode: 'urn:mail:' + "irsaliyepk@" + fields[1],
				}
			});
		}
	}

	closeAddAliasModal() {
		this.setState({
			selectedServiceOption: null,
			addAliasModal: false,
			properSenderAlias: {
				workScopecode: '',
				userRolecode: 'GB'
			},
			properRecipientAlias: {
				workScopecode: '',
				userRolecode: 'PK'
			},
			senderAlias: {
				workScopecode: '',
				userRolecode: 'GB'
			},
			recipientAlias: {
				workScopecode: '',
				userRolecode: 'PK'
			},
			data: {
				automaticExtension: false,
				customerContractServiceList: [],
				contractStartDate: null,
				contractFinishDate: null,
			},
			gbFaturaAliasError: {
				...this.state.gbFaturaAliasError,
				show: false
			},
			pkFaturaAliasError: {
				...this.state.pkFaturaAliasError,
				show: false
			},
			gbIrsaliyeAliasError: {
				...this.state.gbIrsaliyeAliasError,
				show: false
			},
			pkIrsaliyeAliasError: {
				...this.state.pkIrsaliyeAliasError,
				show: false
			}
		})
	}

	saveNewAlias() {
		let selectedServiceOption = this.state.selectedServiceOption;

		let fakeSInput = {
			target: {
				id: 'tSenderAlias',
				value: this.state.senderAlias.workScopecode,
				dataset: {
					vdata: 'email',
					vlength: '1,350'
				}
			}
		};

		let fakeRInput = {
			target: {
				id: 'tRecipientAlias',
				value: this.state.recipientAlias.workScopecode,
				dataset: {
					vdata: 'email',
					vlength: '1,350'
				}
			}
		};

		this.validateField(fakeSInput);
		this.validateField(fakeRInput);

		if (this.state.error.tSenderAlias.valid || this.state.error.tRecipientAlias.valid) {
			let fService = {recordId: 2};
			let iService = {recordId: 6};

			let properSenderAlias = deepCopyObject(this.state.properSenderAlias);
			let properRecipientAlias = deepCopyObject(this.state.properRecipientAlias);

			let eFaturaIndex = this.state.eFaturaIndex;
			let eFaturaContractIndex = this.state.eFaturaContractIndex;
			let eIrsaliyeIndex = this.state.eIrsaliyeIndex;
			let eIrsaliyeContractIndex = this.state.eIrsaliyeContractIndex;
			let customer = deepCopyObject(this.props.customer);

			if (selectedServiceOption) {
				if (selectedServiceOption === 2) {

					properSenderAlias.service = fService;
					properRecipientAlias.service = fService;

					let gbFound = false;
					let pkFound = false;
					customer.customerContractList[eFaturaContractIndex].customerContractServiceList[eFaturaIndex].aliasList.map(alias => {
						if (alias.userRolecode === 'GB' && alias.workScopecode === properSenderAlias.workScopecode) {
							gbFound = true;
						}
						if (alias.userRolecode === 'PK' && alias.workScopecode === properRecipientAlias.workScopecode) {
							pkFound = true;
						}
					});

					if (!gbFound && !pkFound) {
						if(properSenderAlias.workScopecode !=="" )
							customer.customerContractList[eFaturaContractIndex].customerContractServiceList[eFaturaIndex].aliasList.push(this.splitAlias(properSenderAlias, 'gb'));
						if(properRecipientAlias.workScopecode !=="" )
							customer.customerContractList[eFaturaContractIndex].customerContractServiceList[eFaturaIndex].aliasList.push(this.splitAlias(properRecipientAlias, 'pk'));

						if (properSenderAlias.workScopecode !== "" || properRecipientAlias.workScopecode !== "") {
							if (properSenderAlias.workScopecode === "" || properRecipientAlias.workScopecode === "") {
								this.setState({
									alert: (
										<SweetAlert showCancel warning
													confirmBtnText="Onayla"
													cancelBtnText="İptal"
													confirmBtnBsStyle="danger"
													cancelBtnBsStyle="default"
													title="UYARI"
													onConfirm={() =>{ this.props.updateCustomer(customer);this.setState({alert: null})}}
													onCancel={() =>{this.setState({alert: null})}}
										>
											{'Etiketlerinizden birini girmediniz, devam etmek istediğinize emin misiniz?'}
										</SweetAlert>
									)
								});
							} else {
								this.props.updateCustomer(customer);
							}
						}

						this.setState({
							senderAlias: {
								workScopecode: '',
								userRolecode: 'GB'
							},
							recipientAlias: {
								workScopecode: '',
								userRolecode: 'PK'
							},
						});
						this.setContractToCustomer();
						this.closeAddAliasModal();
					} else {
						this.setState({
							gbFaturaAliasError: {
								...this.state.gbFaturaAliasError,
								show: gbFound
							},
							pkFaturaAliasError: {
								...this.state.pkFaturaAliasError,
								show: pkFound
							},
							gbIrsaliyeAliasError: {
								...this.state.gbIrsaliyeAliasError,
								show: false
							},
							pkIrsaliyeAliasError: {
								...this.state.pkIrsaliyeAliasError,
								show: false
							},
						});
					}


				} else if (selectedServiceOption === 6) {

					properSenderAlias.service = iService;
					properRecipientAlias.service = iService;

					let gbFound = false;
					let pkFound = false;
					customer.customerContractList[eIrsaliyeContractIndex].customerContractServiceList[eIrsaliyeIndex].aliasList.map(alias => {
						if (alias.userRolecode === 'GB' && alias.workScopecode === properSenderAlias.workScopecode) {
							gbFound = true;
						}
						if (alias.userRolecode === 'PK' && alias.workScopecode === properRecipientAlias.workScopecode) {
							pkFound = true;
						}
					});
					if (!gbFound && !pkFound) {
						if(properSenderAlias.workScopecode !=="" )
							customer.customerContractList[eIrsaliyeContractIndex].customerContractServiceList[eIrsaliyeIndex].aliasList.push(this.splitAlias(properSenderAlias, 'gb'));
						if(properRecipientAlias.workScopecode !=="" )
							customer.customerContractList[eIrsaliyeContractIndex].customerContractServiceList[eIrsaliyeIndex].aliasList.push(this.splitAlias(properRecipientAlias, 'pk'));

						if (properSenderAlias.workScopecode !== "" || properRecipientAlias.workScopecode !== "") {
							if (properSenderAlias.workScopecode === "" || properRecipientAlias.workScopecode === "") {
								this.setState({
									alert: (
										<SweetAlert showCancel warning
													confirmBtnText="Onayla"
													cancelBtnText="İptal"
													confirmBtnBsStyle="danger"
													cancelBtnBsStyle="default"
													title="UYARI"
													onConfirm={() =>{ this.props.updateCustomer(customer);this.setState({alert: null})}}
													onCancel={() =>{this.setState({alert: null})}}
										>
											{'Etiketlerinizden birini girmediniz, devam etmek istediğinize emin misiniz?'}
										</SweetAlert>
									)
								});
							} else {
								this.props.updateCustomer(customer);
							}
						}

						this.setState({
							senderAlias: {
								workScopecode: '',
								userRolecode: 'GB'
							},
							recipientAlias: {
								workScopecode: '',
								userRolecode: 'PK'
							},
						});
						this.setContractToCustomer();
						this.closeAddAliasModal();
					} else {
						this.setState({
							gbIrsaliyeAliasError: {
								...this.state.gbIrsaliyeAliasError,
								show: gbFound
							},
							pkIrsaliyeAliasError: {
								...this.state.pkIrsaliyeAliasError,
								show: pkFound
							},
							gbFaturaAliasError: {
								...this.state.gbFaturaAliasError,
								show: false
							},
							pkFaturaAliasError: {
								...this.state.pkFaturaAliasError,
								show: false
							}
						});
					}

				} else {

					properSenderAlias.service = fService;
					properRecipientAlias.service = fService;

					let gbFoundForEFatura = false;
					let pkFoundForEFatura = false;
					let gbFoundForEIrsaliye = false;
					let pkFoundForEIrsaliye = false;

					customer.customerContractList[eFaturaContractIndex].customerContractServiceList[eFaturaIndex].aliasList.map(alias => {
						if (alias.userRolecode === 'GB' && alias.workScopecode === properSenderAlias.workScopecode) {
							gbFoundForEFatura = true;
						}
						if (alias.userRolecode === 'PK' && alias.workScopecode === properRecipientAlias.workScopecode) {
							pkFoundForEFatura = true;
						}
					});

					customer.customerContractList[eIrsaliyeContractIndex].customerContractServiceList[eIrsaliyeIndex].aliasList.map(alias => {
						if (alias.userRolecode === 'GB' && alias.workScopecode === properSenderAlias.workScopecode) {
							gbFoundForEIrsaliye = true;
						}
						if (alias.userRolecode === 'PK' && alias.workScopecode === properRecipientAlias.workScopecode) {
							pkFoundForEIrsaliye = true;
						}
					});

					if (!gbFoundForEFatura && !pkFoundForEFatura && !gbFoundForEIrsaliye && !pkFoundForEIrsaliye) {
						if(properSenderAlias.workScopecode !=="" )
							customer.customerContractList[eFaturaContractIndex].customerContractServiceList[eFaturaIndex].aliasList.push(this.splitAlias(properSenderAlias, 'gb'));
						if(properRecipientAlias.workScopecode !=="" )
							customer.customerContractList[eFaturaContractIndex].customerContractServiceList[eFaturaIndex].aliasList.push(this.splitAlias(properRecipientAlias, 'pk'));

						let cloneProperSenderAlias = deepCopyObject(properSenderAlias);
						let cloneProperRecipientAlias = deepCopyObject(properRecipientAlias);
						cloneProperSenderAlias.service = iService;
						cloneProperRecipientAlias.service = iService;
						if(properSenderAlias.workScopecode !=="" )
							customer.customerContractList[eIrsaliyeContractIndex].customerContractServiceList[eIrsaliyeIndex].aliasList.push(this.splitAlias(cloneProperSenderAlias, 'gb'));
						if(properRecipientAlias.workScopecode !=="" )
							customer.customerContractList[eIrsaliyeContractIndex].customerContractServiceList[eIrsaliyeIndex].aliasList.push(this.splitAlias(cloneProperRecipientAlias, 'pk'));

						if (properSenderAlias.workScopecode !== "" || properRecipientAlias.workScopecode !== "") {
							if (properSenderAlias.workScopecode === "" || properRecipientAlias.workScopecode === "") {
								this.setState({
									alert: (
										<SweetAlert showCancel warning
													confirmBtnText="Onayla"
													cancelBtnText="İptal"
													confirmBtnBsStyle="danger"
													cancelBtnBsStyle="default"
													title="UYARI"
													onConfirm={() =>{ this.props.updateCustomer(customer);this.setState({alert: null})}}
													onCancel={() =>{this.setState({alert: null})}}
										>
											{'Etiketlerinizden birini girmediniz, devam etmek istediğinize emin misiniz?'}
										</SweetAlert>
									)
								});
							} else {
								this.props.updateCustomer(customer);
							}
						}

						this.setState({
							senderAlias: {
								workScopecode: '',
								userRolecode: 'GB'
							},
							recipientAlias: {
								workScopecode: '',
								userRolecode: 'PK'
							},
						});
						this.setContractToCustomer();
						this.closeAddAliasModal();
					} else {
						if (gbFoundForEFatura) {
							this.setState({
								gbFaturaAliasError: {
									...this.state.gbFaturaAliasError,
									show: gbFoundForEFatura
								}
							});
						}
						if (pkFoundForEFatura) {
							this.setState({
								pkFaturaAliasError: {
									...this.state.pkFaturaAliasError,
									show: pkFoundForEFatura
								}
							})
						}
						if (gbFoundForEIrsaliye) {
							this.setState({
								gbIrsaliyeAliasError: {
									...this.state.gbIrsaliyeAliasError,
									show: gbFoundForEIrsaliye
								}
							});
						}
						if (pkFoundForEIrsaliye) {
							this.setState({
								pkIrsaliyeAliasError: {
									...this.state.pkIrsaliyeAliasError,
									show: pkFoundForEIrsaliye
								}
							})
						}
					}
				}
			} else {
				Alert.error('Etiket eklemek istediğiniz hizmeti seçiniz', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}
		} else {
			Alert.error('Geçerli bir etiket giriniz', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	updateCustomer() {
		let self = this;
		const data = self.props.customer;
		let params = {
			url: `/customer/createCustomer`,
			data: data,
			method: 'post'
		};
		request(params)
			.then(() => {
				Alert.success('Yeni etiket eklendi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	checkDateValidity(current, name) {
		let copyCurrent = current.clone();
		if (name === 'contractStartDate') {
			return copyCurrent.isAfter(Datetime.moment().subtract(1, 'days'));
		}
		if (name === 'contractFinishDate') {
			return copyCurrent.isAfter(this.state.selectedStartDate);
		}
	}

	existsAlready() {
		let serviceList = deepCopyObject(this.state.serviceList);
		if (this.props.distributorContractList !== null && this.props.distributorContractList.length > 0) {
			this.state.customer.customerContractList.forEach(cc => {
				cc.customerContractServiceList.forEach(ccs => {
					serviceList = serviceList.filter(service => {
						if (typeof ccs.service === 'object') {
							return !(service.ublCode === ccs.service.ublCode && !ccs.terminated);
						} else {
							return service.recordId !== ccs.service.recordId;
						}
					});
				});
			});
		}

		this.setState({ serviceList });
	}

	closeCreateModeAliasModal() {
		let aliasList = deepCopyObject(this.state.aliasList);
		if (this.state.editingAlias === true) {
			let data = deepCopyObject(this.state.data);
			let editingAliasList = deepCopyObject(this.state.editingAliasList);
			editingAliasList.map(eal => {
				aliasList.map(al => {
					if (eal.workScopecode === al.workScopecode) {
						let index = aliasList.indexOf(al);
						aliasList.splice(index, 1);
					}
				});
				data.customerContractServiceList[0].aliasList.map(dal => {
					if (eal.workScopecode === dal.workScopecode) {
						let index = data.customerContractServiceList[0].aliasList.indexOf(dal);
						data.customerContractServiceList[0].aliasList.splice(index, 1);
					}
				})
			});
			this.props.passRecentAliasList(aliasList);
			this.setState({
				data,
				createModeAliasModal: false,
				editingAlias: false,
				aliasList,
				senderAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				recipientAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				},
				properSenderAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				properRecipientAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				}
			}, () => this.removeAlias(editingAliasList))
		} else {
			this.setState({
				createModeAliasModal: false,
				manual: true,
				aliasList: [],
				senderAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				recipientAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				},
				properSenderAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				properRecipientAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				}
			}, () => this.inputElement.click(), this.props.passRecentAliasList([]))
		}
	}

	closeCreateModeDespatchAliasModal() {
		let despatchAliasList = deepCopyObject(this.state.despatchAliasList);
		if (this.state.editingDespatchAlias === true) {
			let data = deepCopyObject(this.state.data);
			let editingDespatchAliasList = deepCopyObject(this.state.editingDespatchAliasList);
			editingDespatchAliasList.map(eal => {
				despatchAliasList.map(al => {
					if (eal.workScopecode === al.workScopecode) {
						let index = despatchAliasList.indexOf(al);
						despatchAliasList.splice(index, 1);
					}
				});
				data.customerContractServiceList[0].aliasList.map(dal => {
					if (eal.workScopecode === dal.workScopecode) {
						let index = data.customerContractServiceList[0].aliasList.indexOf(dal);
						data.customerContractServiceList[0].aliasList.splice(index, 1);
					}
				})
			});
			this.props.passRecentAliasList(despatchAliasList);
			this.setState({
				data,
				createModeDespatchAliasModal: false,
				editingDespatchAlias: false,
				despatchAliasList,
				// senderAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'GB'
				// },
				// recipientAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'PK'
				// },
				// properSenderAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'GB'
				// },
				// properRecipientAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'PK'
				// }
			}, () => this.removeAlias(editingDespatchAliasList))
		} else {
			this.setState({
				createModeDespatchAliasModal: false,
				manual: true,
				// aliasList: [],
				// senderAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'GB'
				// },
				// recipientAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'PK'
				// },
				// properSenderAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'GB'
				// },
				// properRecipientAlias: {
				// 	workScopecode: '',
				// 	userRolecode: 'PK'
				// }
			}, () => this.inputDespatchElement.click())
		}
	}

	removeAlias(data) {
		this.props.removeAlias(data);
		this.setState({
			editingAliasList: [],
			editingSenderAlias: {
				workScopecode: '',
				userRolecode: 'GB'
			},
			editingRecipientAlias: {
				workScopecode: '',
				userRolecode: 'PK'
			},
		})
	}

	confirmCreateModeAliasModal() {
		if (this.state.aliasList.length !== 0) {
			this.setState({
				createModeAliasModal: false,
				editingSenderAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				editingRecipientAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				},
				editingAliasList: []
			})
		} else {
			this.setState({
				createModeAliasModal: false,
				editingSenderAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				editingRecipientAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				},
				editingAliasList: []
			}, this.inputElement.click())
		}
	}

	updateAliasList(data) {
		let ccList = deepCopyObject(this.state.customerContractList);
		ccList.map(cc => {
			let ccsList = cc.customerContractServiceList;
			ccsList.map(ccs => {
				let aliasList = ccs.aliasList;
				aliasList.map(alias => {
					if (alias.recordId === data.recordId) {
						if (alias.actionType === 'C') {
							alias.actionType = 'P'
						} else {
							alias.actionType = 'C'
						}
					}
				})
			})
		});
		this.setState({customerContractList: ccList});
	}

	updateWorkscopeCode(data) {
		let ccList = deepCopyObject(this.state.customerContractList);
		ccList.map(cc => {
			let ccsList = cc.customerContractServiceList;
			ccsList.map(ccs => {
				let aliasList = ccs.aliasList;
				aliasList.map(alias => {
					if (alias.recordId === data.recordId) {
						alias.workScopecode = data.workScopecode;
					}
				})
			})
		});
		this.setState({customerContractList: ccList});
	}

	deleteAlias(data) {
		let ccList = deepCopyObject(this.state.customerContractList);

		ccList.map(cc => {
			let ccsList = cc.customerContractServiceList;
			ccsList.map(ccs => {
				let aliasList = ccs.aliasList;
				aliasList.map(alias => {
					let index = aliasList.findIndex( item => item.recordId === data.recordId);
					if(index > -1){
						aliasList.splice(index,1);
					}
				});
			});
		});

		this.props.reFetchCustomer();
	}

	deleteService(data) {
		let ccList = deepCopyObject(this.state.customerContractList);

		ccList.map(cc => {
			let ccsList = cc.customerContractServiceList;
			ccsList.map(ccs => {
				let index = ccsList.findIndex( item => item.recordId === data.recordId);
				if(index > -1){
					ccsList.splice(index,1);
				}
			});
		});

		this.props.reFetchCustomer();
	}

    deleteContract(data){
        let ccList = deepCopyObject(this.state.customerContractList);

        ccList.map(cc => {
            let index = ccList.findIndex( item => item.recordId === data.recordId);
            if(index > -1){
                ccList.splice(index,1);
            }
        });

		this.props.reFetchCustomer();
	}

	checkIfDespatchAliasExists() {
		let despatchAliasList = deepCopyObject(this.state.despatchAliasList);

		return despatchAliasList.length > 0;
	}

	arrangeDespatchAliasGbOptions() {
		let aliasList = null;
		if (this.state.mode === 'create') {
			aliasList = deepCopyObject(this.state.aliasOptionListForDespatch);
		} else {
			aliasList = this.fillAliasList(null);
		}
		let despatchAliasList = deepCopyObject(this.state.despatchAliasList);
		let temp = aliasList && aliasList.length > 0 && aliasList.filter(alias => {
			return (alias.service && (alias.service === 'EFatura' || alias.service.recordId === 2) && alias.userRolecode === 'GB')
		});
		let despatchGbOptionList = [];
		temp && temp.map(alias => {
			let gbOption = {};
			let found = false;
			despatchAliasList && despatchAliasList.map(despatchAlias => {
				if ((alias.workScopecode === despatchAlias.workScopecode) && (alias.userRolecode === despatchAlias.userRolecode)) {
					found = true;
				}
			});
			if (!found) {
				gbOption.label = alias.workScopecode;
				gbOption.value = alias.workScopecode;
				despatchGbOptionList.push(gbOption);
			}
		});
		return despatchGbOptionList;
	}

	arrangeDespatchAliasPkOptions() {
		let aliasList = null;
		if (this.state.mode === 'create') {
			aliasList = deepCopyObject(this.state.aliasOptionListForDespatch);
		} else {
			aliasList = this.fillAliasList(null);
		}
		let despatchAliasList = deepCopyObject(this.state.despatchAliasList);
		let temp = aliasList && aliasList.length > 0 && aliasList.filter(alias => {
			return (alias.service && (alias.service === 'EFatura' || alias.service.recordId === 2) && alias.userRolecode === 'PK')
		});
		let despatchPkOptionList = [];
		temp && temp.map(alias => {
			let pkOption = {};
			let found = false;
			despatchAliasList && despatchAliasList.map(despatchAlias => {
				if ((alias.workScopecode === despatchAlias.workScopecode) && (alias.userRolecode === despatchAlias.userRolecode)) {
					found = true;
				}
			});
			if (!found) {
				pkOption.label = alias.workScopecode;
				pkOption.value = alias.workScopecode;
				despatchPkOptionList.push(pkOption);
			}
		});
		return despatchPkOptionList;
	}

	setConfigurationList(list) {
		this.setState({
			ConfigurationList: list
		})
		this.props.addServices(list);
	}

	confirmCreateModeDespatchAliasModal() {
		if (this.state.despatchAliasList.length !== 0) {
			this.setState({
				createModeDespatchAliasModal: false,
				editingSenderDespatchAlias: {
					workScopecode: '',
					userRolecode: 'GB',
				},
				editingRecipientDespatchAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				},
				editingDespatchAliasList: []
			})
		} else {
			this.setState({
				createModeDespatchAliasModal: false,
				editingSenderDespatchAlias: {
					workScopecode: '',
					userRolecode: 'GB'
				},
				editingRecipientDespatchAlias: {
					workScopecode: '',
					userRolecode: 'PK'
				},
				editingDespatchAliasList: []
			}, this.inputDespatchElement.click())
		}
	}

	selectServiceForNewAlias(e) {
		this.setState({
			selectedServiceOption: e.value
		})
	}

	selectStyle(item) {
		let error = deepCopyObject(this.state.error);
		if (error[item] === undefined || error[item].valid) {
			return null;
		} else {
			return {backgroundColor: '#f8f8f8', borderColor: '#ffcfcf'}
		}
	}

	onChangeAliasRadio(selection) {
		let eFaturaAliasRadio = null;
		let newAliasRadio = null;
		if (selection === 'existed') {
			eFaturaAliasRadio = !deepCopyObject(this.state.eFaturaAliasRadio);
			newAliasRadio = !eFaturaAliasRadio;
		} else {
			newAliasRadio = !deepCopyObject(this.state.newAliasRadio);
			eFaturaAliasRadio = !newAliasRadio;
		}
		if (this.state.customer.corporateMail && this.state.customer.corporateMail !== "") {
			let fields = this.props.customer.corporateMail.split('@');
			this.setState({
				eFaturaAliasRadio,
				newAliasRadio,
				senderDespatchAlias: {
					workScopecode: "irsaliyegb@" + fields[1],
					userRolecode: 'GB',
					service: ''
				},
				recipientDespatchAlias: {
					workScopecode: "irsaliyepk@" + fields[1],
					userRolecode: 'PK',
					service: ''
				},
				properSenderDespatchAlias: {
					...this.state.properSenderDespatchAlias,
					workScopecode: 'urn:mail:' + "irsaliyegb@" + fields[1],
					userRolecode: 'GB',
					service: ''
				},
				properRecipientDespatchAlias: {
					...this.state.properRecipientDespatchAlias,
					workScopecode: 'urn:mail:' + "irsaliyepk@" + fields[1],
					userRolecode: 'PK',
					service: ''
				}
			});
		}
		if (EntegratorConf.identifier === EntegratorIdentifiers.KOLAYSOFT) {
			this.setState({
				eFaturaAliasRadio,
				newAliasRadio,
				senderDespatchAlias: {
					workScopecode: "irsaliyegb@kolaysoft.com.tr",
					userRolecode: 'GB',
					service: 'EIrsaliye'
				},
				recipientDespatchAlias: {
					workScopecode: "irsaliyepk@kolaysoft.com.tr",
					userRolecode: 'PK',
					service: 'EIrsaliye'
				},
				properSenderDespatchAlias: {
					...this.state.properSenderDespatchAlias,
					workScopecode: 'urn:mail:' + "irsaliyegb@kolaysoft.com.tr",
					userRolecode: 'GB',
					service: 'EIrsaliye'
				},
				properRecipientDespatchAlias: {
					...this.state.properRecipientDespatchAlias,
					workScopecode: 'urn:mail:' + "irsaliyepk@kolaysoft.com.tr",
					userRolecode: 'PK',
					service: 'EIrsaliye'
				}
			});
		}
		if (EntegratorConf.identifier === EntegratorIdentifiers.MBT) {
			this.setState({
				eFaturaAliasRadio,
				newAliasRadio,
				senderDespatchAlias: {
					workScopecode: "irsaliyegb@mbtfatura.com.tr",
					userRolecode: 'GB',
					service: 'EIrsaliye'
				},
				recipientDespatchAlias: {
					workScopecode: "irsaliyepk@mbtfatura.com.tr",
					userRolecode: 'PK',
					service: 'EIrsaliye'
				},
				properSenderDespatchAlias: {
					...this.state.properSenderDespatchAlias,
					workScopecode: 'urn:mail:' + "irsaliyegb@mbtfatura.com.tr",
					userRolecode: 'GB',
					service: 'EIrsaliye'
				},
				properRecipientDespatchAlias: {
					...this.state.properRecipientDespatchAlias,
					workScopecode: 'urn:mail:' + "irsaliyepk@mbtfatura.com.tr",
					userRolecode: 'PK',
					service: 'EIrsaliye'
				}
			});
		} else if (EntegratorConf.identifier !== EntegratorIdentifiers.MBT && EntegratorConf.identifier !== EntegratorIdentifiers.KOLAYSOFT) {
			this.setState({
				eFaturaAliasRadio,
				newAliasRadio,
				senderDespatchAlias: {
					workScopecode: "",
					userRolecode: 'GB',
					service: ''
				},
				recipientDespatchAlias: {
					workScopecode: "",
					userRolecode: 'PK',
					service: ''
				},
				properSenderDespatchAlias: {
					...this.state.properSenderDespatchAlias,
					workScopecode: 'urn:mail:',
					userRolecode: 'GB',
					service: ''
				},
				properRecipientDespatchAlias: {
					...this.state.properRecipientDespatchAlias,
					workScopecode: 'urn:mail:',
					userRolecode: 'PK',
					service: ''
				}
			});
		}
	}
	setSelectedContract(data) {
		this.setState({
			selectedContract: data
		})
		this.serviceOptionSelectable(data)
	}

	serviceOptionSelectable(data) {

		let fExists = false;
		let dExists = false;
		data.customerContractServiceList.map(ccs => {
			if (((typeof ccs.service === 'object' && ccs.service.recordId === 2)) && !ccs.terminated) {
				fExists = true;
			}
			if (((typeof ccs.service === 'object' && ccs.service.recordId === 6)) && !ccs.terminated) {
				dExists = true;
			}
		});

		if (fExists && dExists) {
			return null;
		} else if (fExists && !dExists) {
			this.setState({
				selectedServiceOption: 2
			});
		} else if (!fExists && dExists) {
			this.setState({
				selectedServiceOption: 6
			});
		} else {
			return null;
		}
	};

	onChangeRateType(e) {
		let data = deepCopyObject(this.state.data);

		data.rateType = e.value;

		this.setState({
				data
			}
			// , () => this.props.setContractToCustomer(data)
		);
	}

	manipulateContractRateType(data) {
		let customerContractList = deepCopyObject(this.state.customerContractList);
		let contract = customerContractList.filter(cc => {
			return cc.recordId === data.recordId
		});
		contract[0].rateType === 1 ? contract[0].rateType = 2 : contract[0].rateType = 1;
		this.setState({
			customerContractList
		}, () => {
			this.props.setNewContractList(customerContractList);
		})
	}

	manipulateContractFinishDate(data) {

		let customerContractList = deepCopyObject(this.state.customerContractList);

		customerContractList.map(cc => {
			if (cc.recordId === data.recordId) {

				let newFinishDate = moment(cc.contractFinishDate).add(1, 'YEARS').format('YYYY-MM-DD');

				return cc.contractFinishDate = newFinishDate;
			}
		});
		this.setState({customerContractList})
	}

	updateContractDates(contractId, newStartDate, newFinishDate) {
		let customerContractList = deepCopyObject(this.state.customerContractList);
		let customer = deepCopyObject(this.state.customer);

		let currentStartDate = null;
		let currentFinishDate = null;
		let currentContractId = contractId;

		customerContractList.map(c => {
			if (c.recordId === contractId) {
				if (newStartDate) {
					currentStartDate = c.contractStartDate;
					c.contractStartDate = newStartDate;
				}
				currentFinishDate = c.contractFinishDate;
				c.contractFinishDate = newFinishDate;
			}
		});

		customer.customerContractList = customerContractList;

		this.setState({
			currentStartDate,
			currentFinishDate,
			currentContractId,
			customerContractList,
			customer
		}, () => this.props.updateCustomer(customer));
	}

	completeUpdate() {
		this.setState({
			currentStartDate: null,
			currentFinishDate: null
		});
	}

	render() {

		const rateTypeOptions = [
			{value: 1, label: 'Faturalı'},
			{value: 2, label: 'Kontörlü'}
		];

		const serviceOptions = [
			{value: 2, label: 'e-Fatura'},
			{value: 6, label: 'e-İrsaliye'},
			{value: 62, label: 'e-Fatura ve e-İrsaliye'}
		];

		const columns = [
			{
				Header: "Ekle",
				width: '3%',
				Cell: row => (
					<Label check>
						{(row.ublName === 'EFatura' || row.ublName === 'EIrsaliye') ?
							<Input
								innerRef={input => row.ublName === 'EFatura' ? this.inputElement = input : this.inputDespatchElement = input}
								type="checkbox" name="contractCheckbox"
								onChange={(e) => this.onSelectService(row, e)}/> :
							<Input type="checkbox" name="contractCheckbox"
								   onChange={(e) => this.onSelectService(row, e)}/>}
					</Label>
				)
			},
			{
				Header: "Hizmet",
				width: '15%',
				accessor: "ublCode",
				sortable: false,
				Cell: (row) => (
					<div>
						{row.ublName === 'EFatura' ?
							<span>
							{this.state.eFaturaSelected ?
								<span>E-Fatura -----> <button
									onClick={() => this.setState({
										createModeAliasModal: true,
										editingAlias: true
									})}>Etiketler</button></span> :
								<span>E-Fatura</span>}
						</span> :
							(row.ublName === 'EIrsaliye' ?
								<span>
							{(this.state.eIrsaliyeSelected && this.checkIfDespatchAliasExists()) ?
								<span>E-İrsaliye -----> <button
									onClick={() => this.setState({
										createModeDespatchAliasModal: true,
										editingDespatchAlias: true
									})}>Etiketler</button></span> :
								<span>E-İrsaliye</span>}
						</span> : <span>{row.ublCode}</span>)}
					</div>
				)
			},
			{
				Header: "Ücret",
				width: '10%',
				accessor: "price",
				sortable: false,
				Cell: (row) => (
					<NumberFormat value={this.state.data.paymentExchangeRate}
								  allowNegative={false}
								  isNumericString={true}
								  thousandSeparator={'.'} decimalSeparator={','}
								  suffix={this.state.suffix}
								  displayType="input"
								  isAllowed={values => {
									  return (values.value !== "");
								  }}
								  renderText={value => {
									  value.replace(/\./g, ',')
								  }}
								  onValueChange={(cell) => this.onChangeServiceInfo({
									  value: cell.value,
									  target: {
										  name: "price"
									  }
								  }, row)}
								  className="form-control"/>
				)
			},
			{
				Header: "Açıklama",
				width: '15%',
				accessor: "explanation",
				sortable: false,
				Cell: (row) => (
					<input className="form-control" type="text" name="explanation"
						   onChange={(cell) => this.onChangeServiceInfo(cell, row)}/>
				)
			}
		];

		const aliasColumns = [
			{
				Header: "Etiket",
				accessor: "workScopecode",
				sortable: false
			},
			{
				Header: "Birim",
				accessor: "userRolecode",
				sortable: false
			},
		];
		const { isMobile } = this.state;
		return (
			<div>
				{this.state.alert}
				{this.state.mode === 'edit' && 

				<div className="">

					{((this.props.isEntegrator || this.props.isDistributor) && this.state.customer && !isVakifbankUser(this.state.customer.parentCustomerId, EntegratorConf.identifier)) &&
					<div className="col-sm-12 form-row">
						<div className="col-sm-4 row" style={{left: '-28px'}}>
							<div className="col-sm-8" style={{padding: '0 0 0 44px'}}>
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
											marginBottom: '10px'
										}}
										rel="tooltip"
										disabled={this.props.fieldsDisabled}
										className={this.props.customer.recordId === this.props.currentUser.customerId && !this.props.isEntegrator ? "d-none" : "TekBtn ekle btn-icon"}
										onClick={() => {
											this.openContractModal()
										}}>
									Yenİ Sözleşme Ekle
								</button>
							</div>
						</div>
					</div>}
					<div className={isMobile ? "" : "col-sm-12 "}>
						{this.props.distributorContractList !== null && this.props.distributorContractList && Array.isArray(this.props.distributorContractList) &&
						this.props.distributorContractList.length>0&& this.props.distributorContractList.map((contract) =>
							<DistributorContractAccordion distributorContract={contract}
													   currentCustomer={this.state.customer.recordId}
													   isEntegrator={this.props.isEntegrator}
													   isDistributor={this.props.isDistributor}
													   isAdminUser={this.props.isAdminUser}
													   currentUser={this.props.currentUser}
													   name={this.props.name}
													   fieldsDisabled={this.props.fieldsDisabled}
							/>
						)}
						{this.state.customerContractList !== null && this.state.customerContractList.map((contract) =>
							<CustomerContractAccordion customerContract={contract}
													   impersonateUserRoleId={this.props.impersonateUserRoleId}
													   currentCustomer={this.state.customer.recordId}
													   parentCustomerId={this.state.customer.parentCustomerId}
													   onChangeInvalidatedContractPrice={this.props.onChangeInvalidatedContractPrice}
													   onChangeInvalidatedContractExplanation={this.props.onChangeInvalidatedContractExplanation}
													   customerContractList={this.state.customerContractList}
													   addNewAliasToContract={this.addNewAliasToContract}
													   updateAliasList={this.updateAliasList}
													   aliasList={this.state.aliasList}
													   isEntegrator={this.props.isEntegrator}
													   isDistributor={this.props.isDistributor}
													   isAdminUser={this.props.isAdminUser}
													   setSelectedContract={this.setSelectedContract}
													   manipulateContractList={this.props.manipulateContractList}
													   currentUser={this.props.currentUser}
													   rateType={this.state.data.rateType}
													   onChangeRateType={this.onChangeRateType}
													   manipulateContractRateType={this.manipulateContractRateType}
													   expiringContracts={this.props.expiringContracts}
													   redefineExpiringContracts={this.props.redefineExpiringContracts}
													   manipulateContractFinishDate={this.manipulateContractFinishDate}
													   updateContractDates={this.updateContractDates}
													   currentStartDate={this.state.currentStartDate}
													   currentFinishDate={this.state.currentFinishDate}
													   currentContractId={this.state.currentContractId}
													   completeUpdate={this.completeUpdate}
													   history={this.props.history}
													   name={this.props.name}
													   fieldsDisabled={this.props.fieldsDisabled}
													   updateWorkscopeCode = {this.updateWorkscopeCode}
													   deleteAlias = {this.deleteAlias}
													   deleteService = {this.deleteService}
                                                       deleteContract = {this.deleteContract}
													   reFetchCustomer ={this.props.reFetchCustomer}
													   accordionDeleteSelectList={this.accordionDeleteSelectList}
							/>
						)}
					</div>

					<Modal isOpen={this.state.newContractModal} size='lg'>
						<ModalHeader toggle={this.cancelCurrentContract}>Sözleşme Detayları</ModalHeader>
						<ModalBody>

							<div className="col-sm-12 FormRenk2 row"
								 style={{marginLeft: '0', padding: '15px 0 10px 0'}}>
								<div className="col-sm-4">
									<label className="col-sm-12 form-col-label">Sözleşme
										Başlangıç Tarihi *</label>
									<div className="col-sm-12">
										<div
											className={"form-group" + this.validateClass("tContractStartDate")}>
											<Datetime locale="tr"

													  className="datepicker"
													  input={true}
													  inputProps={{
														  id: 'tContractStartDate',
														  dataset: {
															  vdata: "date",
															  vlength: "1,255",
															  value: this.state.data.contractStartDate
														  }
													  }}
													  onBlur={(momentObj) => this.validateField({
														  target: {
															  id: "tContractStartDate",
															  dataset: {
																  'vdata': "required",
																  'vlength': "1,255"
															  },
															  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
														  }
													  })}
													  closeOnSelect={true}
													  value={moment(this.state.csd)}
													  dateFormat="DD-MM-YYYY"
													  ref="tContractStartDate"
													  isValidDate={(current) => this.checkDateValidity(current, 'contractStartDate')}
													  timeFormat={false}
													  onChange={(e) => this.onChangeContractDate(e, 'contractStartDate')}/>
											{this.validateMessage("tContractStartDate") !== "" &&
											<UncontrolledTooltip placement="right" target={"tContractStartDate"}
																 delay={0}>
												{this.validateMessage("tContractStartDate")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-sm-4">
									<label className="col-sm-12 form-col-label">Sözleşme
										Bitiş Tarihi *</label>
									<div className="col-sm-12">
										<div
											className={"form-group" + this.validateClass("tContractFinishDate")}>
											<Datetime locale="tr"
													  className="datepicker"
													  input={true}
													  inputProps={{
														  id: 'tContractFinishDate',
														  dataset: {
															  vdata: "date",
															  vlength: "1,255",
															  value: this.state.data.contractFinishDate
														  }
													  }}
													  onBlur={(momentObj) => this.validateField({
														  target: {
															  id: "tContractFinishDate",
															  dataset: {
																  'vdata': "required",
																  'vlength': "1,255"
															  },
															  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
														  }
													  })}
													  closeOnSelect={true}
													  value={moment(this.state.cfd)}
													  dateFormat="DD-MM-YYYY"
													  ref="tContractFinishDate"
													  isValidDate={(current) => this.checkDateValidity(current, 'contractFinishDate')}
													  timeFormat={false}
													  onChange={(e) => this.onChangeContractDate(e, 'contractFinishDate')}/>
											{this.validateMessage("tContractFinishDate") !== "" &&
											<UncontrolledTooltip placement="right"
																 target={"tContractFinishDate"} delay={0}>
												{this.validateMessage("tContractFinishDate")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-sm-2" style={{padding: '0', marginTop: '-5px', left: '-5px'}}>
									<label className="col-sm-12 col-form-label" style={{marginBottom: '-2px'}}>Sözleşme
										Türü</label>
									<div className="col-sm-12 form-group">
										<Select
											clearable={false}
											className="select-control"
											name="rateType"
											id="tRateType"
											value={this.state.data.rateType}
											disabled={disAllowChooseContractType(EntegratorConf.identifier, this.props.currentUser.customerId, this.props.isAdminUser)}
											placeholder="Seçiniz..."
											onChange={(e) => this.onChangeRateType(e)}
											options={rateTypeOptions}
										/>
									</div>
								</div>

								<div className="col-sm-2" style={{padding: '0', marginTop: '-4px'}}>
									<label className="col-sm-12" style={{padding: '0'}}>Otomatik Uzatma</label>
									<Label className="col-sm-12" check style={{paddingLeft: '65px'}}>
										<Input type="checkbox" onChange={() => this.onSelectExtension()}/>
									</Label>
								</div>
							</div>

							<div className="card-body">
								<Table
									columns={columns}
									content={this.state.activeService ? this.state.activeServiceList : this.state.serviceList}
									page={this.state.page}
									size={this.state.size}
									paginationEnabled={false}
									total={this.state.activeService ? this.state.activeServiceList.length : this.state.serviceList.length}
									fetchData={this.arrangeData}
								/>
							</div>


						</ModalBody>

						
						<ModalFooter>
							<div className="col-sm-12">
								<nav className=" col-sm-12 row">
									<div className="col-sm-2">
										<button type="button" data-toggle="tooltip" data-placement="bottom"
												style={{background: '#9e9e9e', padding: '11px 45px 11px 20px'}}
												rel="tooltip" className="TekBtn vazgec"
												onClick={() => this.cancelCurrentContract()}>İptal
										</button>
									</div>
									<div className="col-sm-8"></div>
									<div className="col-sm-2">
										<button type="button" data-toggle="tooltip" data-placement="bottom"
												style={{
													background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
													padding: '11px 45px 11px 20px'
												}}
												rel="tooltip" className="TekBtn ekle "
												onClick={() => this.addNewContract()}>Ekle
										</button>


									</div>
								</nav>
							</div>
						</ModalFooter>
					</Modal>
				</div>
				}

				{this.state.mode === 'create' &&
				<div>
					<div className="col-sm-12 form-row row" style={{marginBottom: '25px'}}>
						<div className="col-sm-4">
							<label className="col-sm-12 col-form-label">Sözleşme Başlangıç Tarihi *</label>
							<div className="col-sm-12">
								<div className={"form-group" + this.validateClass("tContractStartDate")}>
									<Datetime locale="tr"
											  className="datepicker"
											  input={true}
											  inputProps={{
												  id: 'tContractStartDate',
												  dataset: {
													  vdata: "date",
													  vlength: "1,255",
													  value: this.state.data.contractStartDate
												  }
											  }}
											  onBlur={(momentObj) => this.validateField({
												  target: {
													  id: "tContractStartDate",
													  dataset: {'vdata': "required", 'vlength': "1,255"},
													  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
												  }
											  })}
											  closeOnSelect={true}
											  value={moment(this.state.csd)}
											  dateFormat="DD-MM-YYYY"
											  ref="tContractStartDate"
											  isValidDate={(current) => this.checkDateValidity(current, 'contractStartDate')}
											  timeFormat={false}
											  onChange={(e) => this.onChangeContractDate(e, 'contractStartDate')}/>
									{this.validateMessage("tContractStartDate") !== "" &&
									<UncontrolledTooltip placement="right" target={"tContractStartDate"} delay={0}>
										{this.validateMessage("tContractStartDate")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>

						<div className="col-sm-4">
							<label className="col-sm-12 col-form-label">Sözleşme Bitiş Tarihi *</label>
							<div className="col-sm-12">
								<div className={"form-group" + this.validateClass("tContractFinishDate")}>
									<Datetime locale="tr"
											  className="datepicker"
											  input={true}
											  inputProps={{
												  id: 'tContractFinishDate',
												  dataset: {
													  vdata: "date",
													  vlength: "1,255",
													  value: this.state.data.contractFinishDate
												  }
											  }}
											  onBlur={(momentObj) => this.validateField({
												  target: {
													  id: "tContractFinishDate",
													  dataset: {'vdata': "required", 'vlength': "1,255"},
													  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
												  }
											  })}
											  closeOnSelect={true}
											  value={moment(this.state.cfd)}
											  dateFormat="DD-MM-YYYY"
											  ref="tContractFinishDate"
											  isValidDate={(current) => this.checkDateValidity(current, 'contractFinishDate')}
											  timeFormat={false}
											  onChange={(e) => this.onChangeContractDate(e, 'contractFinishDate')}/>
									{this.validateMessage("tContractFinishDate") !== "" &&
									<UncontrolledTooltip placement="right" target={"tContractFinishDate"} delay={0}>
										{this.validateMessage("tContractFinishDate")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>

						<div className="col-sm-2">
							<label className="col-sm-12 col-form-label">Sözleşme Türü</label>
							<div className="col-sm-12 form-group">
								<Select
									clearable={false}
									className="select-control"
									name="rateType"
									id="tRateType"
									value={this.state.data.rateType}
									disabled={disAllowChooseContractType(EntegratorConf.identifier, this.props.currentUser.customerId, this.props.isAdminUser)}
									placeholder="Seçiniz..."
									onChange={(e) => this.onChangeRateType(e)}
									options={rateTypeOptions}
								/>
							</div>
						</div>

						<div className="col-sm-2">
							<label className="col-sm-12 col-form-label">Otomatik Uzatma</label>
							<div className="col-sm-12">
								<Input type="checkbox" style={{marginLeft: '3px'}}
									   onChange={() => this.onSelectExtension()}/>
							</div>
						</div>
					</div>

					<div className="card-body">
						<Table
							columns={columns}
							content={this.state.serviceList}
							page={this.state.page}
							size={this.state.size}
							paginationEnabled={false}
							total={this.state.serviceList.length}
							fetchData={this.arrangeData}
						/>

					</div>
				</div>
				}

				<Modal isOpen={this.state.addAliasModal} size="lg">
					<ModalHeader toggle={this.closeAddAliasModal}>Yeni Etiket Ekleyin</ModalHeader>
					<ModalBody>
						<div>
							<div className="col-sm-12" style={{textAlign: 'center'}}>
								<label>Etiketler e-Posta formatında olmalıdır.</label>
							</div>
							<br/>
							{!this.state.selectedServiceOption &&
							<div className="col-sm-12 row">
								<div className='col-sm-5'>
									<label>Etiket eklemek istediğiniz hizmeti seçiniz :</label>
								</div>
								<div className='col-sm-7'>
									<Select
										clearable={false}
										options={serviceOptions}
										value={this.state.selectedServiceOption}
										onChange={(e) => this.selectServiceForNewAlias(e)}
										placeholder={'Seçiniz...'}
									/>
								</div>
							</div>}
							<br/>
							<div className='col-sm-12 row'>
								<div className='col-sm-6 row'>
									<div className='col-sm-5'></div>
									<InlineError errorObject={this.state.gbFaturaAliasError} className='col-sm-7'/>
								</div>
								<div className='col-sm-6 row'>
									<div className='col-sm-5'></div>
									<InlineError errorObject={this.state.pkFaturaAliasError} className='col-sm-7'/>
								</div>
							</div>
							<div className='col-sm-12 row'>
								<div className='col-sm-6 row'>
									<div className='col-sm-5'></div>
									<InlineError errorObject={this.state.gbIrsaliyeAliasError} className='col-sm-7'/>
								</div>
								<div className='col-sm-6 row'>
									<div className='col-sm-5'></div>
									<InlineError errorObject={this.state.pkIrsaliyeAliasError} className='col-sm-7'/>
								</div>
							</div>
							<div className="col-sm-12 form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-5">
										<label className="col-form-label">Gönderici Etiketi *</label>
									</div>
									<div className="col-sm-7" style={{maxWidth: "none"}}>
										<div className={"form-group" + this.validateClass('tSenderAlias')}>
											<input className="form-control"
												   type="text"
												   name="senderAlias"
												   id="tSenderAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   disabled={!this.state.selectedServiceOption}
												   onBlur={this.validateField}
												   ref="tSenderAlias"
												   value={this.state.senderAlias.workScopecode}
												   onChange={(e) => this.onChangeAlias(e)}/>
											{this.validateMessage('tSenderAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tSenderAlias" delay={0}>
												{this.validateMessage("tSenderAlias")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-sm-6 row">
									<div className="col-sm-5">
										<label className="col-form-label">Alıcı Etiketi *</label>
									</div>
									<div className="col-sm-7">
										<div className={"form-group" + this.validateClass('tRecipientAlias')}>
											<input className="form-control"
												   type="text"
												   name="recipientAlias"
												   id="tRecipientAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   disabled={!this.state.selectedServiceOption}
												   onBlur={this.validateField}
												   ref="tRecipientAlias"
												   value={this.state.recipientAlias.workScopecode}
												   onChange={(e) => this.onChangeAlias(e)}/>
											{this.validateMessage('tRecipientAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tRecipientAlias" delay={0}>
												{this.validateMessage("tRecipientAlias")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>
							</div>

							<div className="col-sm-12 form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-5"></div>
									<div className="col-sm-7">
										<label>{this.state.properSenderAlias.workScopecode}</label>
									</div>
								</div>

								<div className="col-sm-6 row">
									<div className="col-sm-5"></div>
									<div className="col-sm-7">
										<label>{this.state.properRecipientAlias.workScopecode}</label>
									</div>


								</div>

								{(this.state.customer && !isVakifbankUser(this.state.customer.parentCustomerId, EntegratorConf.identifier)) &&
								<div className="col-sm-12">
									<nav className="col-sm-12 row">
										<div className="col-sm-2">
											<button type="button" className="TekBtn vazgec"
													style={{background: 'rgb(158, 158, 158)'}}
													onClick={() => this.closeAddAliasModal()}>İptal
											</button>
										</div>
										<div className="col-sm-8"/>
								
										<div className="col-sm-2">
											<button type="button" className="TekBtn ekle btn-icon"
													onClick={() => {
														this.saveNewAlias()
													}}>Etİket Ekle
											</button>
										</div>
									</nav>
								</div>}

							</div>
						</div>
					</ModalBody>
					<ModalFooter>
					</ModalFooter>
				</Modal>

				<Modal isOpen={this.state.createModeAliasModal} size="lg">
					<ModalHeader toggle={this.closeCreateModeAliasModal}>Etiket Ekleyin</ModalHeader>
					<ModalBody>
						<div>
							<div className="col-sm-12" style={{textAlign: 'center'}}>
								<label>Etiketler e-Posta formatında olmalıdır.</label>
							</div>
							<br/>
							<div className="col-sm-12 form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-6">
										<label style={{whiteSpace: 'nowrap'}}>Gönderici Etiketi *</label>
									</div>
									<div className="col-sm-6 row " style={{maxWidth: "none"}}>
										{this.state.aliasList.length === 0 &&
										<div className={"form-group" + this.validateClass('tSenderAlias')}>
											<input className="form-control"
												   type="text"
												   name="senderAlias"
												   id="tSenderAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tSenderAlias"
												   value={this.state.senderAlias.workScopecode}
												   onChange={(e) => this.onChangeAlias(e)}/>
											{this.validateMessage('tSenderAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tSenderAlias" delay={0}>
												{this.validateMessage("tSenderAlias")}
											</UncontrolledTooltip>}
										</div>}

										{this.state.aliasList.length !== 0 &&
										<div className={"form-group" + this.validateClass('tSenderAlias')}>
											<input className="form-control"
												   type="text"
												   name="senderAlias"
												   id="tSenderAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tSenderAlias"
												   value={this.state.senderAlias.workScopecode}
												   onChange={(e) => this.onChangeAlias(e)}/>
										</div>}
									</div>
								</div>
								<div className="col-sm-6 row">
									<div className="col-sm-6 ">
										<label style={{whiteSpace: 'nowrap'}}>Alıcı Etiketi *</label>
									</div>
									<div className="col-sm-6 row" style={{maxWidth: "none"}}>
										{this.state.aliasList.length === 0 &&
										<div className={"form-group" + this.validateClass('tRecipientAlias')}>
											<input className="form-control"
												   type="text"
												   name="recipientAlias"
												   id="tRecipientAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tRecipientAlias"
												   value={this.state.recipientAlias.workScopecode}
												   onChange={(e) => this.onChangeAlias(e)}/>
											{this.validateMessage('tRecipientAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tRecipientAlias" delay={0}>
												{this.validateMessage("tRecipientAlias")}
											</UncontrolledTooltip>}
										</div>}

										{this.state.aliasList.length !== 0 &&
										<div className={"form-group" + this.validateClass('tRecipientAlias')}>
											<input className="form-control"
												   type="text"
												   name="recipientAlias"
												   id="tRecipientAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tRecipientAlias"
												   value={this.state.recipientAlias.workScopecode}
												   onChange={(e) => this.onChangeAlias(e)}/>
										</div>}
									</div>
								</div>
							</div>

							<div className="col-sm-12 row form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-6"></div>
									<div className="col-sm-6">
										<label>{this.state.properSenderAlias.workScopecode}</label>
									</div>
								</div>
								<div className="col-sm-6 row">
									<div className="col-sm-6"></div>
									<div className="col-sm-6">
										<label>{this.state.properRecipientAlias.workScopecode}</label>
									</div>
								</div>

								{(this.state.customer && !isVakifbankUser(this.state.customer.parentCustomerId, EntegratorConf.identifier)) &&
								<div className="col-sm-12 row">
									<div className="col-sm-6">

										<button type="button" data-toggle="tooltip" data-placement="bottom"
												style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
												rel="tooltip" className="TekBtn ekle btn-icon"
												onClick={() => {
													this.addAliasToEFatura()
												}}
										>Etİket Ekle
										</button>

										{/*<button className="TekBtn ekle"*/}
										{/*onClick={() => {*/}
										{/*this.addAliasToEFatura()*/}
										{/*}}>Etİket Ekle*/}
										{/*</button>*/}
									</div>
								</div>}

								<div className="card-body row" style={{marginTop: '0px'}}>
									<Table
										columns={aliasColumns}
										content={this.state.aliasList}
										page={this.state.aPage}
										size={this.state.aSize}
										paginationEnabled={false}
										total={this.state.aliasList.length}
										fetchData={this.arrangeAliasData}
									/>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>

						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{background: 'rgb(158, 158, 158)', padding: '11px 45px 11px 20px'}}
								rel="tooltip" className="TekBtn vazgec btn-icon"
								onClick={() => {
									this.closeCreateModeAliasModal()
								}}>İptal
						</button>
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{
									background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
									padding: '11px 45px 11px 20px'
								}}
								rel="tooltip" className="TekBtn ekle btn-icon"
								onClick={() => this.confirmCreateModeAliasModal()}
						>Tamam
						</button>
					</ModalFooter>
				</Modal>

				<Modal isOpen={this.state.createModeDespatchAliasModal} size="lg">
					<ModalHeader toggle={this.closeCreateModeDespatchAliasModal}>Yeni İrsaliye Etiketi
						Ekleyin</ModalHeader>
					<ModalBody>
						<div>
							<div className="col-sm-12" style={{textAlign: 'center'}}>
								<label>Etiketler e-Posta formatında olmalıdır.</label>
							</div>
							<br/>
							{this.state.aliasList.length > 0 &&
							<div className="col-sm-12 row">
								<div className="col-sm-1" style={{textAlign: 'center', padding: '0'}}>
									<input type='radio' checked={this.state.eFaturaAliasRadio}
										   onChange={() => this.onChangeAliasRadio('existed')}/>
								</div>
								<div className='col-sm-4' style={{textAlign: 'left', padding: '0'}}>
									<label>e-Fatura etiketlerinden seç</label>
								</div>
								{/*<div className='col-sm-1'/>*/}
								<div className="col-sm-1" style={{textAlign: 'center', padding: '0'}}>
									<input type='radio' checked={this.state.newAliasRadio}
										   onChange={() => this.onChangeAliasRadio('new')}/>
								</div>
								<div className='col-sm-4' style={{textAlign: 'left', padding: '0'}}>
									<label>Yeni etiket belirle</label>
								</div>
							</div>}
							<br/>
							<div className="col-sm-12 form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-4">
										<label style={{whiteSpace: 'nowrap'}}>Gönderici Etiketi *</label>
									</div>
									{this.state.newAliasRadio &&
									<div className="col-sm-8" style={{maxWidth: "none"}}>
										{this.state.despatchAliasList.length === 0 &&
										<div className={"form-group" + this.validateClass('tSenderDespatchAlias')}>
											<input className="form-control"
												   type="text"
												   name="senderDespatchAlias"
												   id="tSenderDespatchAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tSenderDespatchAlias"
												   value={this.state.senderDespatchAlias.workScopecode}
												   onChange={(e) => this.onChangeDespatchAlias(e)}/>
											{this.validateMessage('tSenderDespatchAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tSenderDespatchAlias"
																 delay={0}>
												{this.validateMessage("tSenderDespatchAlias")}
											</UncontrolledTooltip>}
										</div>}

										{this.state.despatchAliasList.length !== 0 &&
										<div className={"form-group" + this.validateClass('tSenderDespatchAlias')}>
											<input className="form-control"
												   type="text"
												   name="senderDespatchAlias"
												   id="tSenderDespatchAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tSenderDespatchAlias"
												   value={this.state.senderDespatchAlias.workScopecode}
												   onChange={(e) => this.onChangeDespatchAlias(e)}/>
										</div>}
									</div>}

									{this.state.eFaturaAliasRadio &&
									<div className="col-sm-8" style={{maxWidth: "none"}}>
										{this.state.despatchAliasList.length === 0 &&
										<div className={"form-group" + this.validateClass('tSenderDespatchAlias')}>
											<Select
												id='tSenderDespatchAlias'
												ref='tSenderDespatchAlias'
												clearable={false}
												onChange={(e) => this.onChangeDespatchAlias(e, 'senderDespatchAlias')}
												options={this.arrangeDespatchAliasGbOptions()}
												onBlur={() => this.validateField(
													{
														target: {
															id: "tSenderDespatchAlias",
															value: this.state.properSenderDespatchAlias.workScopecode,
															dataset: {
																vdata: "required"
															}
														}
													})}
												style={this.selectStyle('tSenderDespatchAlias')}
												value={this.state.properSenderDespatchAlias.workScopecode}/>
											{this.validateMessage('tSenderDespatchAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tSenderDespatchAlias"
																 delay={0}>
												{this.validateMessage("tSenderDespatchAlias")}
											</UncontrolledTooltip>}
										</div>}

										{this.state.despatchAliasList.length !== 0 &&
										<div className="form-group">
											<Select
												id='tSenderDespatchAlias'
												ref='tSenderDespatchAlias'
												clearable={false}
												onChange={(e) => this.onChangeDespatchAlias(e, 'senderDespatchAlias')}
												options={this.arrangeDespatchAliasGbOptions()}
												onBlur={() => this.validateField(
													{
														target: {
															id: "tSenderDespatchAlias",
															value: this.state.properSenderDespatchAlias.workScopecode,
															dataset: {
																vdata: "required"
															}
														}
													})}
												style={this.selectStyle('tSenderDespatchAlias')}
												value={this.state.properSenderDespatchAlias.workScopecode}/>
											{this.validateMessage('tSenderDespatchAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tSenderDespatchAlias"
																 delay={0}>
												{this.validateMessage("tSenderDespatchAlias")}
											</UncontrolledTooltip>}
										</div>}
									</div>}
								</div>
								<div className="col-sm-6 row">
									<div className="col-sm-4">
										<label style={{whiteSpace: 'nowrap'}}>Alıcı Etiketi *</label>
									</div>
									{this.state.newAliasRadio &&
									<div className="col-sm-8" style={{maxWidth: "none"}}>
										{this.state.despatchAliasList.length === 0 &&
										<div className={"form-group" + this.validateClass('tRecipientDespatchAlias')}>
											<input className="form-control"
												   type="text"
												   name="recipientDespatchAlias"
												   id="tRecipientDespatchAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tRecipientDespatchAlias"
												   value={this.state.recipientDespatchAlias.workScopecode}
												   onChange={(e) => this.onChangeDespatchAlias(e)}/>
											{this.validateMessage('tRecipientDespatchAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tRecipientDespatchAlias"
																 delay={0}>
												{this.validateMessage("tRecipientDespatchAlias")}
											</UncontrolledTooltip>}
										</div>}

										{this.state.despatchAliasList.length !== 0 &&
										<div className={"form-group" + this.validateClass('tRecipientDespatchAlias')}>
											<input className="form-control"
												   type="text"
												   name="recipientDespatchAlias"
												   id="tRecipientDespatchAlias"
												   data-vlength="1,350"
												   data-vdata="email"
												   ref="tRecipientDespatchAlias"
												   value={this.state.recipientDespatchAlias.workScopecode}
												   onChange={(e) => this.onChangeDespatchAlias(e)}/>
										</div>}
									</div>}

									{this.state.eFaturaAliasRadio &&
									<div className="col-sm-8" style={{maxWidth: "none"}}>
										{this.state.despatchAliasList.length === 0 &&
										<div className={"form-group" + this.validateClass('tRecipientDespatchAlias')}>
											<Select
												id='tRecipientDespatchAlias'
												ref="tRecipientDespatchAlias"
												clearable={false}
												onChange={(e) => this.onChangeDespatchAlias(e, 'recipientDespatchAlias')}
												options={this.arrangeDespatchAliasPkOptions()}
												onBlur={() => this.validateField(
													{
														target: {
															id: "tRecipientDespatchAlias",
															value: this.state.properRecipientDespatchAlias.workScopecode,
															dataset: {
																vdata: "required"
															}
														}
													})}
												style={this.selectStyle('tRecipientDespatchAlias')}
												value={this.state.properRecipientDespatchAlias.workScopecode}/>
											{this.validateMessage('tRecipientDespatchAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tRecipientDespatchAlias"
																 delay={0}>
												{this.validateMessage("tRecipientDespatchAlias")}
											</UncontrolledTooltip>}
										</div>}

										{this.state.despatchAliasList.length !== 0 &&
										<div className="form-group">
											<Select
												id='tRecipientDespatchAlias'
												ref="tRecipientDespatchAlias"
												clearable={false}
												onChange={(e) => this.onChangeDespatchAlias(e, 'recipientDespatchAlias')}
												options={this.arrangeDespatchAliasPkOptions()}
												onBlur={() => this.validateField(
													{
														target: {
															id: "tRecipientDespatchAlias",
															value: this.state.properRecipientDespatchAlias.workScopecode,
															dataset: {
																vdata: "required"
															}
														}
													})}
												style={this.selectStyle('tRecipientDespatchAlias')}
												value={this.state.properRecipientDespatchAlias.workScopecode}/>
											{this.validateMessage('tRecipientDespatchAlias') !== "" &&
											<UncontrolledTooltip placement="right" target="tRecipientDespatchAlias"
																 delay={0}>
												{this.validateMessage("tRecipientDespatchAlias")}
											</UncontrolledTooltip>}
										</div>}
									</div>}
								</div>
							</div>

							<div className="col-sm-12 row form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-6"></div>
									<div className="col-sm-6">
										<label>{this.state.properSenderDespatchAlias.workScopecode}</label>
									</div>
								</div>
								<div className="col-sm-6 row">
									<div className="col-sm-6"></div>
									<div className="col-sm-6">
										<label>{this.state.properRecipientDespatchAlias.workScopecode}</label>
									</div>
								</div>

								{(this.state.customer && !isVakifbankUser(this.state.customer.parentCustomerId, EntegratorConf.identifier)) &&
								<div className="col-sm-12 row">
									<div className="col-sm-6">

										<button type="button" data-toggle="tooltip" data-placement="bottom"
												style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
												rel="tooltip" className="TekBtn ekle btn-icon"
												onClick={() => {
													this.addAliasToEIrsaliye()
												}}
										>Etİket Ekle
										</button>
									</div>
								</div>}

								<div className="card-body row" style={{marginTop: '0px'}}>
									<Table
										columns={aliasColumns}
										content={this.state.despatchAliasList}
										page={this.state.aPage}
										size={this.state.aSize}
										paginationEnabled={false}
										total={this.state.despatchAliasList.length}
										fetchData={this.arrangeAliasData}
									/>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{background: 'rgb(158, 158, 158)', padding: '11px 45px 11px 20px'}}
								rel="tooltip" className="TekBtn vazgec btn-icon"
								onClick={() => {
									this.closeCreateModeDespatchAliasModal()
								}}>İptal
						</button>
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{
									background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
									padding: '11px 45px 11px 20px'
								}}
								rel="tooltip" className="TekBtn ekle btn-icon"
								onClick={() => this.confirmCreateModeDespatchAliasModal()}
						>Tamam
						</button>
					</ModalFooter>
				</Modal>
			</div>
		)
	}
}

export default CustomerContractInfo;